import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import CircularProgress from "@mui/material/CircularProgress";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { styled as materialStyles } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import info from "../../../assets/icon.png";
import Checkbox from "@mui/material/Checkbox";
import { useForm, Controller } from "react-hook-form";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useDispatch } from "react-redux";
import { getCommodityGroupsThunk } from "../../commodityGroup/redux/commodityGroupSlice";
import { getMaterialGroupsThunk } from "../../materialGroup/redux/materialGroupSlice";
import { getSubCategoriesThunk } from "../../subCategory/redux/subCategorySlice";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import LoadingButton from "@mui/lab/LoadingButton";
import FormGroup from "@mui/material/FormGroup";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import SearchIcon from "@mui/icons-material/Search";
import InfoIcon from "@mui/icons-material/Info";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

import {
  vendorRegistrationUpdate,
  hsnCategories,
  hsnValues,
  getVendorDetails,
  itemValues,
  submitVendorEdit,
  validateMSMENumber,
} from "../redux/vendorRegistrationSlice";
import {
  UserInfoDiv,
  VendorCardTitle,
  VendorInstructions,
  VendorListHolder,
} from "./steps/vendorRegEdit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "styled-components";
import BankRegEdit from "./steps/bankRegEdit";
import BankReg from "./steps/bankReg";
import BankDetailsManager from "./steps/BankDetailsManager";
import VendorDocumentRequests from "../../documentRequests/VendorDocumentRequests";
import { useSelector } from "react-redux";
import { BankDisabledFields, Super } from "./steps/cardTrialEdit";
import FormHelperText from "@mui/material/FormHelperText";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
/* import ArrowRightIcon from "@mui/icons-material/ArrowRight"; */
import _without from "lodash/without";
import _ from "lodash";
import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";
import apiClient from "../../../utilities/apiClient";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useParams } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  concernTypeForJaslok,
  CustomFormControl,
  CustomFormSelection,
} from "./StepMain";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import { Clear, Edit, FileDownload } from "@mui/icons-material";
import { VendorCardBlankTitle } from "./steps/cardTrial";
import VRF_vishakha from "../../../assets/F-PUR-03-VRF-Vishakha.DOCX";
import MsmeComponents from "../../../common/sharedComponents/styles/msmeComponents";
import { CustomDocumentLink } from "../../../common/sharedComponents/styles/card.style";
import { useFeature } from "../../../common/featureFlags/FeatureProvider";

const Input = materialStyles("input")({
  display: "none",
});
export const radioStyles = {
  selectRadio: {
    border: "1px solid #D9D8FF",
    padding: "0px 7px 0px 7px",
    background: "#D9D8FF",
    borderRadius: "4px",
    marginLeft: "-6px",
  },
};

export const radioStyles1 = {
  selectRadio: {
    border: "1px solid #D9D8FF",
    padding: "0px 7px 0px 7px",
    background: "#D9D8FF",
    borderRadius: "4px",
    marginLeft: "-6px",
    marginRight: "15px",
  },
};
export default function StepMainEdit() {
  const showRequestedDocs = useFeature("requested_documents");
  const isVendorApproval = useFeature("vendor_approval_workflow");
  const isVendorTerms = useFeature("show_vendor_terms");
  const showCommodityGroups = useFeature("show_commodity_groups");
  const showMaterialGroups = useFeature("show_material_groups");
  const showSubCategories = useFeature("show_sub_categories");
  const showWebsite = useFeature("show_website");
  const showYearOfEstablishment = useFeature("show_year_of_establishment");
  const showCinValidation = useFeature("cin_registration");
  const showIecRegistration = useFeature("iec_registration");
  const showFactoryRegistration = useFeature("factory_license_registration");
  const showEprRegistration = useFeature("epr_registration");
  const showPollutionRegistration = useFeature(
    "pollution_control_registration",
  );
  const showMajorCustomerList = useFeature("show_major_customer_list");
  const showAffirmativeAction = useFeature("show_affirmative_action");
  const showRegInfoCard =
    showCinValidation ||
    showIecRegistration ||
    showFactoryRegistration ||
    showEprRegistration ||
    showPollutionRegistration;
  const steps = [
    "Vendor Details",
    "Business Details",
    "Bank Details",
    "Documents",
    "Finish",
  ];

  const vendorCompany = LocalStorage.getItem("client");
  const value = LocalStorage.getItem(SESSION_KEY);
  const {
    categories,
    subcategories,
    vendor_details,
    itemcategories,
    msmeLoading,
  } = useSelector((state) => state.vendorRegistration);

  const [userdata, setUserdata] = useState({
    cin_applicable: "Not Applicable",
    iec_applicable: "Not Applicable",
    factory_license_applicable: "Not Applicable",
    epr_applicable: "Not Applicable",
    pollution_control_applicable: "Not Applicable",
  });
  const [activeStep, setActiveStep] = useState(0);
  const [checkedMSME, setCheckedMSME] = useState(false);
  const [validatedMsmeData, setValidatedMsmeData] = useState(null);
  const navigate = useNavigate();
  const isTenant2 = useFeature("tenant2");
  const [finalSubmitLoading, setFinalSubmitLoading] = useState(false);
  const [skipped, setSkipped] = useState(new Set());
  const [checkedPan, setCheckedPan] = useState(false);
  const [majorCustomers, setMajorCustomers] = useState([""]);

  const handleAddCustomer = () => {
    setMajorCustomers([...majorCustomers, ""]);
  };

  const handleRemoveCustomer = (index) => {
    const list = [...majorCustomers];
    list.splice(index, 1);
    setMajorCustomers(list.length > 0 ? list : [""]);
  };

  const handleCustomerChange = (index, value) => {
    const list = [...majorCustomers];
    list[index] = value;
    setMajorCustomers(list);
  };

  const [
    is_accept_vendor_terms_conditions,
    set_is_accept_vendor_terms_conditions,
  ] = useState(false);
  const [vendor_terms_condtions_doc, set_vendor_terms_condtions_doc] =
    useState("");
  const [panDoc, setPanDoc] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [dealer, setDealer] = useState("");
  const [tin, setTin] = useState("");
  const [iso, setIso] = useState("");
  const [coa, setCoa] = useState("");
  const [qualityAudit, setQualityAudit] = useState("");
  const [hazardous, setHazardous] = useState("");
  const [sds, setSds] = useState("");
  const [unCert, setUnCert] = useState("");
  const [vendorSite, setVendorSite] = useState("");
  const [cinDoc, setCinDoc] = useState("");
  const [cinError, setCinError] = useState("");
  const [iecDoc, setIecDoc] = useState("");
  const [iecError, setIecError] = useState("");
  const [factoryDoc, setFactoryDoc] = useState("");
  const [factoryError, setFactoryError] = useState("");
  const [eprDoc, setEprDoc] = useState("");
  const [eprError, setEprError] = useState("");
  const [pollutionDoc, setPollutionDoc] = useState("");
  const [pollutionError, setPollutionError] = useState("");
  const [msmeDoc, setmsmeDoc] = useState("");
  const [checkedType, setCheckedType] = useState("");
  const [subCategory, setSubCategory] = useState("");

  const [anyDocs, setAnyDocs] = useState([]);
  const [userinfo, setUserInfo] = useState({
    codes: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isDetailsLoading, setIsDetailsLoading] = useState(false);
  const [isLoadingsub, setIsLoadingsub] = useState(false);
  const [search, setSearch] = useState("");
  const [searchsub, setSearchsub] = useState("");
  const [catdisplay, setCatdisplay] = useState("none");
  const [subcatdisplay, setSubcatdisplay] = useState("none");

  const [itemcodes, setItemcodes] = useState("");
  const [isLoadingitem, setIsLoadingitem] = useState(false);
  const [searchitem, setSearchitem] = useState("");
  const [itemcatdisplay, setItemcatdisplay] = useState("none");
  const [mSME, setMSME] = useState("");
  const [msmenum, setMsmenum] = useState("");
  const [annualCr, setAnnualCr] = useState("₹0.00 CR");
  const [editMSMEDailog, setEditMSMEDailog] = useState(false);
  const [editMSMENumber, setEditMSMENumber] = useState(null);
  const [isApproved, setIsApproved] = useState(false);
  const [isCompanyNameEditable, setIsCompanyNameEditable] = useState(true);
  const [companyName, setCompanyName] = useState("");
  const [legalName, setLegalName] = useState("");
  const isEditable =
    isCompanyNameEditable &&
    !vendor_details?.vendor_code &&
    !vendor_details?.is_approved;
  const convertToMillions = (e) => {
    let num;
    if (e.target) {
      num = e.target.value;
    } else {
      num = e;
    }
    if (num === undefined) return "";
    const millions = num / 10;

    const ready =
      millions.toLocaleString("en-IN", { style: "currency", currency: "INR" }) +
      " CR";
    setAnnualCr(ready);
  };

  const EditMSMEHandle = () => {
    setEditMSMEDailog(true);
    setCheckedMSME(false);
    setEditMSMENumber(userdata.msme_registration_number || "");
  };
  const msmeEditCancleHandle = () => {
    setEditMSMENumber(null);
    setEditMSMEDailog(false);
  };

  const validateMsme = () => {
    if (!watch("company_constitution") && !userdata?.company_constitution) {
      return message.error("Please select Company constitution first");
    }
    if (!msmenum) {
      return message.info("Please enter MSME Registration Number");
    }
    dispatch(
      validateMSMENumber({
        msme: msmenum,
        company_constitution: userdata?.company_constitution || watch("company_constitution") || "",
        legal_name: value?.legal_name || "",
        user_id: value?.user_id,
      }),
    ).then((response) => {
      const { success, data } = response.payload;
      if (
        success &&
        data?.[0]?.status === "completed" &&
        data?.[0]?.result?.source_output?.status === "id_found"
      ) {
        const sourceOutput = data[0].result.source_output;
        const generalDetails = sourceOutput?.general_details || {};
        const enterpriseTypeData =
          sourceOutput?.enterprise_type?.[0]?.enterprise_type_1 || {};
        setValidatedMsmeData({
          msme_registration_number: msmenum || "",
          msme_type: generalDetails?.enterprise_type || "",
          enterprise_name: generalDetails?.enterprise_name || "",
          enterprise_activity: generalDetails?.major_activity || "",
          classification_date: enterpriseTypeData?.classification_date || "",
          classification_year: enterpriseTypeData?.classification_year || "",
        });
        setCheckedMSME(true);
      } else {
        setCheckedMSME(false);
        setValidatedMsmeData(null);
      }
    });
  };
  const params = useParams();
  const vendor_id = params.id;

  const dispatch = useDispatch();
  const { commodityGroupList } = useSelector((state) => state.commodityGroup);
  const { materialGroupList } = useSelector((state) => state.materialGroup);
  const { subCategoryList } = useSelector((state) => state.subCategory);
  const handleFinalSubmit = () => {
    setFinalSubmitLoading(true);
    const currentVendorId =
      vendor_id || vendor_details?.id || value?.vendor_id || value?.id;
    const payload = {
      vendor_id: currentVendorId,
      is_finish: isTenant2 ? true : false,
    };
    dispatch(submitVendorEdit(payload))
      .unwrap()
      .then((res) => {
        setFinalSubmitLoading(false);
        if (res?.success) {
          message.success("Edits submitted successfully.");
          navigate("/app");
        } else {
          message.info(res?.message || "No pending edits to submit.");
          navigate("/app");
        }
      })
      .catch((err) => {
        setFinalSubmitLoading(false);
        message.error("Failed to submit edits.");
      });
  };

  const onSubmit = (payload) => {
    setLoading(true);
    payload["vendor_id"] = vendor_id;
    dispatch(vendorRegistrationUpdate(payload)).then((response) => {
      if (response?.payload?.success) {
        setLoading(false);
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
          newSkipped = new Set(newSkipped.values());
          newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
        ViewVendordetails(vendor_id);
      } else {
        setLoading(false);
      }
    });
  };
  const ViewVendordetails = (vendor_id) => {
    dispatch(getVendorDetails(vendor_id))
      .then((response) => {
        if (response?.payload?.success) {
          // setUserdata(response?.payload?.data);
          const loadedData = {
            company_name:
              response?.payload?.data?.company_name ||
              response?.payload?.data?.User?.company_name ||
              "",
            legel_name:
              response?.payload?.data?.legal_name ||
              response?.payload?.data?.User?.legal_name ||
              "",
            company_constitution:
              response?.payload?.data?.company_constitution || "",
            company_nature: response?.payload?.data.company_nature,
            commodity_group_id:
              response?.payload?.data?.commodity_group_id || "",
            material_group_id: response?.payload?.data?.material_group_id || "",
            sub_category_id: response?.payload?.data?.sub_category_id || "",
            affirmative_action_category:
              response?.payload?.data.affirmative_action_category,
            business_interest_areas:
              response?.payload?.data.business_interest_areas,
            registration_type: response?.payload?.data.gst_registration_type,
            tax_identification_number:
              response?.payload?.data.tax_identification_number,
            website: response?.payload?.data?.website || "",
            year_of_establishment:
              response?.payload?.data?.year_of_establishment || "",
            annual_turnover: response?.payload?.data.annual_turnover
              ? response?.payload?.data.annual_turnover
              : "",
            ind_annual_turnover: response?.payload?.data.annual_turnover
              ? convertToMillions(response?.payload?.data.annual_turnover)
              : "",
            msme_register: response?.payload?.data?.Msme?.msme_type || "",

            msme_registration_number: response?.payload?.data?.Msme
              ? response?.payload?.data.Msme.registration_number
              : "",
            classification_date: response?.payload?.data?.Msme
              ? response?.payload?.data.Msme.classification_date
              : "",
            classification_year: response?.payload?.data?.Msme
              ? response?.payload?.data.Msme.classification_year
              : "",
            enterprise_activity: response?.payload?.data?.Msme
              ? response?.payload?.data.Msme.enterprise_activity
              : "",
            enterprise_name: response?.payload?.data?.Msme
              ? response?.payload?.data.Msme.enterprise_name
              : "",
            msme_type: response?.payload?.data?.Msme
              ? response?.payload?.data.Msme.msme_type
              : "",
            msme_doc: response?.payload?.data.Documents[0]
              ? response?.payload?.data.Documents[0].msme_certificate_image
              : "",
          };

          const registrations =
            response?.payload?.data?.VendorRegistrations || [];
          const cinReg = registrations.find((r) => r.reg_type === "CIN");
          const iecReg = registrations.find((r) => r.reg_type === "IEC");
          const factoryReg = registrations.find(
            (r) => r.reg_type === "FACTORY_LICENSE",
          );
          const eprReg = registrations.find((r) => r.reg_type === "EPR");
          const pollutionReg = registrations.find(
            (r) => r.reg_type === "POLLUTION_CONTROL",
          );

          loadedData.cin_applicable = cinReg?.applicable
            ? cinReg.applicable
            : cinReg?.document_name || cinReg?.reg_number
              ? "Applicable"
              : "Not Applicable";
          loadedData.cin_number = cinReg?.reg_number || "";
          loadedData.iec_applicable = iecReg?.applicable
            ? iecReg.applicable
            : iecReg?.document_name || iecReg?.reg_number
              ? "Applicable"
              : "Not Applicable";
          loadedData.iec_number = iecReg?.reg_number || "";
          loadedData.factory_license_applicable = factoryReg?.applicable
            ? factoryReg.applicable
            : factoryReg?.document_name || factoryReg?.reg_number
              ? "Applicable"
              : "Not Applicable";
          loadedData.factory_license_number = factoryReg?.reg_number || "";
          loadedData.epr_applicable = eprReg?.applicable
            ? eprReg.applicable
            : eprReg?.document_name || eprReg?.reg_number
              ? "Applicable"
              : "Not Applicable";
          loadedData.epr_number = eprReg?.reg_number || "";
          loadedData.epr_expiry = eprReg?.expiry_date
            ? eprReg.expiry_date.slice(0, 10)
            : "";
          loadedData.pollution_control_applicable = pollutionReg?.applicable
            ? pollutionReg.applicable
            : pollutionReg?.document_name || pollutionReg?.reg_number
              ? "Applicable"
              : "Not Applicable";
          loadedData.pollution_control_number = pollutionReg?.reg_number || "";
          loadedData.pollution_control_expiry = pollutionReg?.expiry_date
            ? pollutionReg.expiry_date.slice(0, 10)
            : "";

          if (cinReg?.document_name) {
            setCinDoc({ name: cinReg.document_name, url: cinReg.document_url });
          }
          if (iecReg?.document_name) {
            setIecDoc({ name: iecReg.document_name, url: iecReg.document_url });
          }
          if (factoryReg?.document_name) {
            setFactoryDoc({
              name: factoryReg.document_name,
              url: factoryReg.document_url,
            });
          }
          if (eprReg?.document_name) {
            setEprDoc({ name: eprReg.document_name, url: eprReg.document_url });
          }
          if (pollutionReg?.document_name) {
            setPollutionDoc({
              name: pollutionReg.document_name,
              url: pollutionReg.document_url,
            });
          }

          if (
            response?.payload?.data?.major_customers &&
            response.payload.data.major_customers.length > 0
          ) {
            setMajorCustomers(
              response.payload.data.major_customers.map((c) => c.customer_name),
            );
          } else {
            setMajorCustomers([""]);
          }

          setUserdata(loadedData);
          reset(loadedData);

          setIsCompanyNameEditable(
            response?.payload?.data?.isCompanyNameEditable ?? true,
          );
          setCompanyName(loadedData.company_name);
          setLegalName(loadedData.legel_name);

          setIsApproved(
            !!response?.payload?.data?.is_fully_approved ||
              !!response?.payload?.data?.is_approved ||
              !!response?.payload?.data?.vendor_code,
          );

          if (response?.payload?.data?.Documents?.[0]?.pan_image_name) {
            setPanDoc({
              name: response?.payload?.data?.Documents
                ? response?.payload?.data?.Documents?.[0]?.pan_image_name
                : "",
            });
          }
          if (
            response?.payload?.data?.Documents?.[0]
              ?.supporting_document_image_name
          ) {
            const fileName =
              response?.payload?.data?.Documents?.[0]
                ?.supporting_document_image_name;
            const filePath =
              response?.payload?.data?.Documents?.[0]
                ?.supporting_document_image;
            const concatResource = fileName.map(function (fileName, index) {
              return { name: fileName, path: filePath[index] };
            });
            setAnyDocs(concatResource);
            setNewDocs(concatResource.length > 0 ? concatResource : [0]);
          }

          if (response?.payload?.data?.Documents?.[0]?.msme_certificate_image) {
            setmsmeDoc({
              name: response?.payload?.data?.Documents
                ? response?.payload?.data?.Documents?.[0]
                    ?.msme_certificate_image_name
                : "",
            });
          }
          if (
            response?.payload?.data?.Documents?.[0]
              ?.dealer_authorization_image_name
          ) {
            setDealer({
              name: response?.payload?.data?.Documents
                ? response?.payload?.data?.Documents?.[0]
                    .dealer_authorization_image_name
                : "",
            });
          }
          if (
            response?.payload?.data?.Documents?.[0]?.tin_certificate_image_name
          ) {
            setTin({
              name: response?.payload?.data?.Documents
                ? response?.payload?.data?.Documents?.[0]
                    .tin_certificate_image_name
                : "",
            });
          }
          if (
            response?.payload?.data?.Documents?.[0]
              ?.iso_or_rsdo_or_any_image_name
          ) {
            setIso({
              name: response?.payload?.data?.Documents
                ? response?.payload?.data?.Documents?.[0]
                    .iso_or_rsdo_or_any_image_name
                : "",
            });
          }
          if (
            response?.payload?.data?.Documents?.[0]
              ?.coa_test_certificate_image_name
          ) {
            setCoa({
              name:
                response?.payload?.data?.Documents?.[0]
                  ?.coa_test_certificate_image_name || "",
            });
          }
          if (
            response?.payload?.data?.Documents?.[0]
              ?.quality_audit_report_image_name
          ) {
            setQualityAudit({
              name:
                response?.payload?.data?.Documents?.[0]
                  ?.quality_audit_report_image_name || "",
            });
          }
          if (
            response?.payload?.data?.Documents?.[0]
              ?.hazardous_material_declaration_image_name
          ) {
            setHazardous({
              name:
                response?.payload?.data?.Documents?.[0]
                  ?.hazardous_material_declaration_image_name || "",
            });
          }
          if (
            response?.payload?.data?.Documents?.[0]
              ?.sds_msds_availability_image_name
          ) {
            setSds({
              name:
                response?.payload?.data?.Documents?.[0]
                  ?.sds_msds_availability_image_name || "",
            });
          }
          if (
            response?.payload?.data?.Documents?.[0]?.un_certificates_image_name
          ) {
            setUnCert({
              name:
                response?.payload?.data?.Documents?.[0]
                  ?.un_certificates_image_name || "",
            });
          }
          if (response?.payload?.data?.Documents?.[0]?.vendor_site_images) {
            setVendorSite({
              name:
                response?.payload?.data?.Documents?.[0]
                  ?.vendor_site_images_name || "Site Image",
              url: response?.payload?.data?.Documents?.[0]?.vendor_site_images,
            });
          }
          if (response?.payload?.data?.hsn_codes?.length) {
            let hsn_codes = response?.payload?.data?.hsn_codes;
            setUserInfo({
              codes: hsn_codes,
            });
          }
          setCheckedPan(response?.payload?.data?.pan_confirmation);
          if (response?.payload?.data?.Msme?.msme_type) {
            setMSME(response.payload.data.Msme.msme_type);
          }
          if (response?.payload?.data?.Msme?.registration_number) {
            setCheckedMSME(true);
          }
          if (response?.payload?.data?.accept_vendor_terms_conditions?.length) {
            set_is_accept_vendor_terms_conditions(
              response?.payload?.data?.accept_vendor_terms_conditions[0]
                ?.is_accept,
            );
            set_vendor_terms_condtions_doc(
              response?.payload?.data?.accept_vendor_terms_conditions[0]
                ?.vendor_terms_and_condition?.terms,
            );
          }
          setIsDetailsLoading(false);
        } else {
          setIsDetailsLoading(false);
        }
      })
      .catch(() => {
        setIsDetailsLoading(false);
      });
  };
  useEffect(() => {
    ViewVendordetails(vendor_id);
    if (value?.user_id) {
      apiClient
        .get(`${apiClient.Urls.apiUrl}/api/user/${value.user_id}`, "", true)
        .then((response) => {
          if (response && response.permanent_account_number) {
            setPanNumber(response.permanent_account_number);
          }
        })
        .catch((err) => {
          console.error("Error fetching PAN number:", err);
        });
    }
  }, []);

  useEffect(() => {
    if (showCommodityGroups) {
      dispatch(getCommodityGroupsThunk({ page: 1, per_page: 1000 }));
    }
    if (showMaterialGroups) {
      dispatch(getMaterialGroupsThunk({ page: 1, per_page: 1000 }));
    }
    if (showSubCategories) {
      dispatch(getSubCategoriesThunk({ page: 1, per_page: 1000 }));
    }
  }, [dispatch, showCommodityGroups, showMaterialGroups, showSubCategories]);

  const getCategories = (payload) => {
    dispatch(hsnCategories(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoading(false);
      }
    });
  };

  const getHSNCodes = (payload) => {
    dispatch(hsnValues(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingsub(false);
      }
    });
  };

  const getItemsCodes = (payload) => {
    dispatch(itemValues(payload)).then((response) => {
      if (response.payload.success === true) {
        setIsLoadingitem(false);
      }
    });
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const [newDocs, setNewDocs] = useState([anyDocs.length]);
  const handleOnClick = () => {
    let docsCopy = [...newDocs];

    docsCopy.push({
      any_docs: "",
    });

    setNewDocs(docsCopy);
  };

  const handlechangeDoc = (e, index) => {
    let newDocValues = [...anyDocs];
    newDocValues[index] = e.target.files[0];
    setAnyDocs(newDocValues);
  };

  const handleRemove = (e, i) => {
    let uploadeddocs = [...newDocs];
    uploadeddocs.splice(i, 1);
    setNewDocs(uploadeddocs);

    let currentAnyDocs = [...anyDocs];
    currentAnyDocs.splice(i, 1);
    setAnyDocs(currentAnyDocs);
  };

  const handleclearDoc = (e, index) => {
    let newDocValues = [...anyDocs];
    newDocValues[index] = "";
    setAnyDocs(newDocValues);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    watch,
    reset,
    setValue,
    control,
    setError,
  } = useForm({
    defaultValues: {
      cin_applicable: "Not Applicable",
      iec_applicable: "Not Applicable",
      factory_license_applicable: "Not Applicable",
      epr_applicable: "Not Applicable",
      pollution_control_applicable: "Not Applicable",
    }
  });

  var user = LocalStorage.getItem(SESSION_KEY);

  const is_domestic = user?.is_domestic;

  const watchedConstitution = watch("company_constitution");
  const watchedCinApplicable = watch("cin_applicable");
  const watchedIecApplicable = watch("iec_applicable");
  const watchedFactoryApplicable = watch("factory_license_applicable");
  const watchedEprApplicable = watch("epr_applicable");
  const watchedPollutionApplicable = watch("pollution_control_applicable");

  const watchedIecNumber = watch("iec_number");
  const watchedFactoryNumber = watch("factory_license_number");
  const watchedEprNumber = watch("epr_number");
  const watchedPollutionNumber = watch("pollution_control_number");

  const isCinForced =
    showCinValidation &&
    is_domestic === true &&
    (watchedConstitution === "Private Limited Company" ||
      watchedConstitution === "Private Limited" ||
      watchedConstitution === "Limited Liability Partnership (LLP)");

  const resolvedCinApplicable = isCinForced
    ? "Applicable"
    : watchedCinApplicable || "Not Applicable";

  useEffect(() => {
    if (showCinValidation) {
      if (isCinForced) {
        setValue("cin_applicable", "Applicable");
        setUserdata((prev) => ({ ...prev, cin_applicable: "Applicable" }));
      } else {
        setValue("cin_applicable", "Not Applicable");
        setUserdata((prev) => ({ ...prev, cin_applicable: "Not Applicable" }));
      }
    }
  }, [watchedConstitution, isCinForced, setValue, showCinValidation]);

  const watchAllFields = watch();
  const handleNext = (data) => {
    let hasError = false;

    const initialConstitution =
      vendor_details?.company_constitution || userdata?.company_constitution || "";
    const isConstitutionChanged =
      Boolean(watchedConstitution) &&
      Boolean(initialConstitution) &&
      watchedConstitution !== initialConstitution;

    const isMsmeApplicable =
      mSME === "Applicable" || (mSME !== "others" && mSME !== "");

    const isMsmeValidationRequired =
      is_domestic &&
      (isMsmeApplicable || (isMsmeApplicable && isConstitutionChanged));

    if (activeStep === 0 && isMsmeValidationRequired) {
      if (!checkedMSME) {
        return message.error(
          "Please validate your MSME registration number before proceeding.",
        );
      }
      if (!msmeDoc) {
        setError("msme", {
          type: "manual",
          message: "Please upload MSME certificate copy",
        });
        hasError = true;
      }
    }

    if (showCinValidation) {
      if (resolvedCinApplicable === "Applicable") {
        if (!data.cin_number) {
          setError("cin_number", {
            type: "manual",
            message: "CIN Number is required",
          });
          hasError = true;
        }
        if (!cinDoc) {
          setCinError("CIN document copy is required");
          hasError = true;
        } else {
          setCinError("");
        }
      } else {
        setCinError("");
      }
    }

    if (showIecRegistration) {
      if (watchedIecApplicable === "Applicable") {
        if (!data.iec_number) {
          setError("iec_number", {
            type: "manual",
            message: "Import Export Code is required",
          });
          hasError = true;
        }
        if (!iecDoc) {
          setIecError("IEC document copy is required");
          hasError = true;
        } else {
          setIecError("");
        }
      } else {
        setIecError("");
      }
    }

    if (showFactoryRegistration) {
      if (watchedFactoryApplicable === "Applicable") {
        if (!data.factory_license_number) {
          setError("factory_license_number", {
            type: "manual",
            message: "Factory License Number is required",
          });
          hasError = true;
        }
        if (!factoryDoc) {
          setFactoryError("Factory license document copy is required");
          hasError = true;
        } else {
          setFactoryError("");
        }
      } else {
        setFactoryError("");
      }
    }

    if (showEprRegistration) {
      if (watchedEprApplicable === "Applicable") {
        if (!data.epr_number) {
          setError("epr_number", {
            type: "manual",
            message: "EPR Number is required",
          });
          hasError = true;
        }
        if (!eprDoc) {
          setEprError("EPR certificate upload is required");
          hasError = true;
        } else {
          setEprError("");
        }
        if (!data.epr_expiry) {
          setError("epr_expiry", {
            type: "manual",
            message: "EPR certificate expiry is required",
          });
          hasError = true;
        }
      } else {
        setEprError("");
      }
    }

    if (showPollutionRegistration) {
      if (watchedPollutionApplicable === "Applicable") {
        if (!data.pollution_control_number) {
          setError("pollution_control_number", {
            type: "manual",
            message: "Pollution Control Certificate Number is required",
          });
          hasError = true;
        }
        if (!pollutionDoc) {
          setPollutionError("Pollution control certificate upload is required");
          hasError = true;
        } else {
          setPollutionError("");
        }
        if (!data.pollution_control_expiry) {
          setError("pollution_control_expiry", {
            type: "manual",
            message: "Pollution control certificate expiry is required",
          });
          hasError = true;
        }
      } else {
        setPollutionError("");
      }
    }

    if (hasError) return;

    var formData = new FormData();

    const resolvedData = {
      ...data,
      msme_registration_number_edit: editMSMENumber,
      cin_applicable: showCinValidation
        ? resolvedCinApplicable
        : "Not Applicable",
      iec_applicable: showIecRegistration
        ? watchedIecApplicable || "Not Applicable"
        : "Not Applicable",
      factory_license_applicable: showFactoryRegistration
        ? watchedFactoryApplicable || "Not Applicable"
        : "Not Applicable",
      epr_applicable: showEprRegistration
        ? watchedEprApplicable || "Not Applicable"
        : "Not Applicable",
      pollution_control_applicable: showPollutionRegistration
        ? watchedPollutionApplicable || "Not Applicable"
        : "Not Applicable",
      major_customers: majorCustomers.filter((name) => name.trim() !== ""),
    };

    if (mSME === "others") {
      resolvedData.msme_register = "others";
      resolvedData.msme_type = "others";
      resolvedData.msme_registration_number = "";
      resolvedData.classification_date = "";
      resolvedData.classification_year = "";
      resolvedData.enterprise_activity = "";
      resolvedData.enterprise_name = "";
    } else if (validatedMsmeData) {
      resolvedData.msme_register = validatedMsmeData.msme_type || "Applicable";
      resolvedData.msme_type = validatedMsmeData.msme_type;
      resolvedData.classification_date = validatedMsmeData.classification_date;
      resolvedData.classification_year = validatedMsmeData.classification_year;
      resolvedData.enterprise_activity = validatedMsmeData.enterprise_activity;
      resolvedData.enterprise_name = validatedMsmeData.enterprise_name;
      resolvedData.msme_registration_number =
        validatedMsmeData.msme_registration_number;
    }

    if (resolvedData.cin_applicable === "Not Applicable") {
      resolvedData.cin_number = "";
    }
    if (resolvedData.iec_applicable === "Not Applicable") {
      resolvedData.iec_number = "";
    }
    if (resolvedData.factory_license_applicable === "Not Applicable") {
      resolvedData.factory_license_number = "";
    }
    if (resolvedData.epr_applicable === "Not Applicable") {
      resolvedData.epr_number = "";
      resolvedData.epr_expiry = "";
    }
    if (resolvedData.pollution_control_applicable === "Not Applicable") {
      resolvedData.pollution_control_number = "";
      resolvedData.pollution_control_expiry = "";
    }

    formData.append("data", JSON.stringify(resolvedData));
    if (mSME === "others") {
      formData.append("msme_certificate_image", "");
      formData.append("msme_certificate_image_edit", "");
    } else if (msmeDoc instanceof File) {
      formData.append("msme_certificate_image", msmeDoc);
      formData.append("msme_certificate_image_edit", msmeDoc);
    } else {
      formData.append("msme_certificate_image", "");
      formData.append("msme_certificate_image_edit", "");
    }

    if (showCinValidation) {
      if (resolvedData.cin_applicable === "Not Applicable" || cinDoc === "")
        formData.append("cin_document_image", "");
      else if (cinDoc instanceof File)
        formData.append("cin_document_image", cinDoc);
    }
    if (showIecRegistration) {
      if (resolvedData.iec_applicable === "Not Applicable" || iecDoc === "")
        formData.append("iec_document_image", "");
      else if (iecDoc instanceof File)
        formData.append("iec_document_image", iecDoc);
    }
    if (showFactoryRegistration) {
      if (
        resolvedData.factory_license_applicable === "Not Applicable" ||
        factoryDoc === ""
      )
        formData.append("factory_license_document_image", "");
      else if (factoryDoc instanceof File)
        formData.append("factory_license_document_image", factoryDoc);
    }
    if (showEprRegistration) {
      if (resolvedData.epr_applicable === "Not Applicable" || eprDoc === "")
        formData.append("epr_document_image", "");
      else if (eprDoc instanceof File)
        formData.append("epr_document_image", eprDoc);
    }
    if (showPollutionRegistration) {
      if (
        resolvedData.pollution_control_applicable === "Not Applicable" ||
        pollutionDoc === ""
      )
        formData.append("pollution_control_document_image", "");
      else if (pollutionDoc instanceof File)
        formData.append("pollution_control_document_image", pollutionDoc);
    }

    formData.append("codes", JSON.stringify(userinfo.codes));
    formData.append("pan_declaration", checkedPan);
    formData.append("vendor_id", vendor_id);
    formData.append("msme_number_edit", editMSMENumber);

    onSubmit(formData);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setCheckedPan(false);
  };
  const handleReset = () => {
    setActiveStep(0);
  };

  const handleChange = (event) => {
    if (event.target.checked) {
      setCheckedPan(true);
    } else {
      setCheckedPan(false);
    }
  };
  const [loading, setLoading] = useState(false);

  const handleadditionalChange = (e, type) => {
    setCheckedType(type);
    // eslint-disable-next-line
    getCategories(type == 2 ? "HSN" : "SAC");
    setIsLoading(true);
    setSearch("");
    setCatdisplay("block");
    setItemcatdisplay("none");
    setSubcatdisplay("none");
  };
  const initialSelected = [];
  const [personName, setPersonName] = useState(initialSelected);
  const handlecategoryChange = (e, type) => {
    setSubCategory(type);
    getHSNCodes(type);
    setIsLoadingsub(true);
    setSearchsub("");
    setSubcatdisplay("block");
    setItemcatdisplay("none");
  };

  const handlesubcategoryChange = (e, type) => {
    setItemcodes(type);
    getItemsCodes(type);
    setIsLoadingitem(true);
    setSearchitem("");
    setItemcatdisplay("block");
  };

  const handleDelete = (chipToDelete) => () => {
    let codes = userinfo.codes;

    let filtered = codes.filter((codes) =>
      codes.toLowerCase().includes(chipToDelete.toLowerCase()),
    );
    const array1 = codes.filter((val) => !filtered.includes(val));
    setUserInfo({
      codes: array1,
    });
    setPersonName((current) => _without(current, chipToDelete));
    // setUserInfo({})
  };

  const handleCheckChange = (e, type) => {
    const { checked } = e.target;
    const { codes } = userinfo;
    if (checked) {
      setUserInfo({
        codes: [...codes, type],
      });
      setPersonName([...personName, type]);
    }
  };

  const handleregistrationChange = (e) => {
    setUserdata((prev) => ({
      ...prev,
      registration_type: e.target.value,
    }));
    setValue("registration_type", e.target.value, { shouldValidate: true });
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const code_filtered = !search
    ? categories
    : categories.filter((categories) =>
        categories.categortDescription
          .toLowerCase()
          .includes(search.toLowerCase()),
      );

  const sub_filtered = !searchsub
    ? subcategories
    : subcategories.filter((subcategories) =>
        subcategories.subCategory
          .toLowerCase()
          .includes(searchsub.toLowerCase()),
      );

  const item_filtered = !searchitem
    ? itemcategories
    : itemcategories.filter((itemcategories) =>
        itemcategories.item.toLowerCase().includes(searchitem.toLowerCase()),
      );

  const onChange = (e) => {
    const { name, value } = e.target;
    setUserdata((prev) => ({ ...prev, [name]: value }));
    setValue(name, value, { shouldValidate: true });
    if (name === "annual_turnover") {
      convertToMillions(e);
    }
    if (name === "msme_register") {
      setUserdata((prev) => ({
        ...prev,
        msme_registration_number: "",
        expiry_date: "",
        msme_register: value,
      }));
    }
  };

  const handlemsme = (value) => {
    setMSME(value);
    setMsmenum("");
    setCheckedMSME(false);
    setValidatedMsmeData(null);
    setmsmeDoc("");
    setValue("msme_register", value, { shouldValidate: true });
  };
  var user = LocalStorage.getItem(SESSION_KEY);

  const card = (
    <CardContent>
      <Typography gutterBottom variant="h6" component="div">
        <VendorInstructions>
          <img src={info} alt="info" /> Instructions
        </VendorInstructions>
      </Typography>
      <br />

      <VendorListHolder>
        <li>
          Enter statutory information which includes company nature,
          constitution and GST registration type.
        </li>
        <li>
          Legal name is auto-populated as per the information on the PAN
          database. It is not editable for vendors.
        </li>
        <li>
          Enter all the mandatory fields before proceeding to enter location
          information.
        </li>
        <li className="text-danger">Documents size cannot exceed 500kb</li>
      </VendorListHolder>
    </CardContent>
  );

  const statutory_information = (
    <CardContent>
      <Container fixed>
        <Grid>
          <VendorCardTitle>Statutory information</VendorCardTitle>
          <UserInfoDiv>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>
                  Company name {isEditable && <Super>*</Super>}
                </VendorCardLabel>
                {isEditable ? (
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    InputProps={{
                      disableUnderline: false,
                      disableInjectingGlobalStyles: true,
                    }}
                    placeholder="Enter company name"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    name="company_name"
                    {...register("company_name", {
                      required: "Please enter company name",
                      value: companyName,
                    })}
                    value={companyName}
                    onChange={(e) => {
                      setCompanyName(e.target.value);
                      setValue("company_name", e.target.value, {
                        shouldValidate: true,
                      });
                    }}
                    error={Boolean(errors?.company_name)}
                    helperText={errors.company_name?.message}
                  />
                ) : (
                  <VendorDisabledFields>
                    {companyName || value.company_name}
                  </VendorDisabledFields>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <VendorCardLabel>Company email</VendorCardLabel>

                <VendorDisabledFields>
                  {value.contact_person_email}
                </VendorDisabledFields>
              </Grid>
              <Grid item xs={12} md={4}>
                <VendorCardLabel>
                  Permanent account number (PAN)
                </VendorCardLabel>

                <VendorDisabledFields>
                  {panNumber ? `${panNumber}` : `International`}
                </VendorDisabledFields>
              </Grid>
            </Grid>
          </UserInfoDiv>
        </Grid>
        <br />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>
              Legal name <Super>*</Super>
            </VendorCardLabel>

            <VendorDisabledFields
              {...register("legel_name", {
                value: value.legal_name,
              })}
              style={{
                borderBottom: "1px solid lightgray",
                width: "100%",
                padding: " 0 0 5px 0",
                paddingTop: "5px",
              }}
            >
              {typeof value.legal_name !== undefined &&
              value.legal_name !== null
                ? `${value.legal_name}`
                : `Not Applicable`}
            </VendorDisabledFields>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.company_constitution)}
            >
              <VendorCardLabel>
                Company constitution <Super>*</Super>
              </VendorCardLabel>
              <Select
                sx={{ fontFamily: "var(--font-family-reg)", fontSize: "14px" }}
                displayEmpty
                defaultValue=""
                IconComponent={() => (
                  <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                )}
                labelId="demo-simple-select-standard-label"
                id="company_constitution"
                label="Company consistution (As per GST certificate)"
                name="company_constitution"
                {...register("company_constitution", {
                  required: "Please select constitution",
                  value: userdata.company_constitution || "",
                })}
                value={watchedConstitution || userdata.company_constitution || ""}
                onChange={(e) => {
                  setValue("company_constitution", e.target.value, { shouldValidate: true });
                  setUserdata((prev) => ({ ...prev, company_constitution: e.target.value }));
                  setCheckedMSME(false);
                  setValidatedMsmeData(null);
                }}
              >
                <MenuItem value="">
                  <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                    Select constitution
                  </span>
                </MenuItem>

                <MenuItem value="Association of Persons (AOP)">
                  <SelectSpan>Association of Persons (AOP)</SelectSpan>
                </MenuItem>
                <MenuItem value="Body of Individuals">
                  <SelectSpan>Body of Individuals</SelectSpan>
                </MenuItem>
                <MenuItem value="Partnership Firm">
                  <SelectSpan>Partnership Firm</SelectSpan>
                </MenuItem>
                <MenuItem value="Individual/One person Company">
                  <SelectSpan>Individual/One person Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Individual">
                  <SelectSpan>Individual</SelectSpan>
                </MenuItem>
                <MenuItem value="Joint Venture (JV)">
                  <SelectSpan>Joint Venture (JV)</SelectSpan>
                </MenuItem>
                <MenuItem value="Limited Liability Partnership (LLP)">
                  <SelectSpan>Limited Liability Partnership (LLP)</SelectSpan>
                </MenuItem>
                <MenuItem value="Limited">
                  <SelectSpan>Limited</SelectSpan>
                </MenuItem>
                <MenuItem value="Limited Company/Listed company">
                  <SelectSpan>Limited Company/Listed company</SelectSpan>
                </MenuItem>
                <MenuItem value="Non banking finance company/ Banking company">
                  <SelectSpan>
                    Non banking finance company/ Banking company
                  </SelectSpan>
                </MenuItem>
                <MenuItem value="Proprietary Firm">
                  <SelectSpan>Proprietary Firm</SelectSpan>
                </MenuItem>
                <MenuItem value="Private Limited Company">
                  <SelectSpan>Private Limited Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Firm">
                  <SelectSpan>Firm</SelectSpan>
                </MenuItem>
                <MenuItem value="Private Limited">
                  <SelectSpan>Private Limited</SelectSpan>
                </MenuItem>
                <MenuItem value="Co-operative society">
                  <SelectSpan>Co-operative society</SelectSpan>
                </MenuItem>
                <MenuItem value="Foreign Company">
                  <SelectSpan>Foreign Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Hindu Undivided Family">
                  <SelectSpan>Hindu Undivided Family</SelectSpan>
                </MenuItem>
                <MenuItem value="Government Organisation">
                  <SelectSpan>Government Organisation</SelectSpan>
                </MenuItem>
                <MenuItem value="Government Company">
                  <SelectSpan>Government Company</SelectSpan>
                </MenuItem>
              </Select>
              <FormHelperText>
                {errors.company_constitution?.message}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.company_nature)}
            >
              <VendorCardLabel>
                Company nature<Super> *</Super>
              </VendorCardLabel>
              <Select
                sx={{ fontFamily: "var(--font-family-reg)", fontSize: "14px" }}
                displayEmpty
                defaultValue=""
                IconComponent={() => (
                  <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                )}
                labelId="demo-simple-select-standard-label"
                id="company_nature"
                label="company_nature"
                name="company_nature"
                {...register("company_nature", {
                  required: "Please select company nature",
                  value: userdata.company_nature || "",
                })}
                value={userdata.company_nature || ""}
                onChange={(e) => onChange(e)}
              >
                <MenuItem value="">
                  <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                    Select company nature
                  </span>
                </MenuItem>

                <MenuItem value="dta">
                  <SelectSpan>Domestic Tariff Area (DTA)</SelectSpan>
                </MenuItem>
                <MenuItem value="domestic">
                  <SelectSpan> Indian Company</SelectSpan>
                </MenuItem>
                <MenuItem value="Foreign Company">
                  <SelectSpan>Foreign Company (Outside India)</SelectSpan>
                </MenuItem>
                <MenuItem value="sez">
                  <SelectSpan>Special Economic Zone (SEZ)</SelectSpan>
                </MenuItem>
                <MenuItem value="stpi">
                  <SelectSpan>
                    Software Technology Parks of India (STPI)
                  </SelectSpan>
                </MenuItem>
              </Select>
              <FormHelperText>{errors.company_nature?.message}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={3}>
          {showAffirmativeAction && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.affirmative_action_category)}
              >
                <VendorCardLabel>Affirmative action category</VendorCardLabel>
                <Select
                  sx={{
                    fontFamily: "var(--font-family-reg)",
                    fontSize: "14px",
                  }}
                  displayEmpty
                  defaultValue=""
                  IconComponent={() => (
                    <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                  )}
                  labelId="demo-simple-select-standard-label"
                  id="affirmative_action_category"
                  label="Affirmative action category"
                  name="affirmative_action_category"
                  {...register("affirmative_action_category", {
                    required: false,
                    value: userdata.affirmative_action_category || "",
                  })}
                  error={Boolean(errors?.affirmative_action_category)}
                  value={userdata.affirmative_action_category || ""}
                  onChange={(e) => onChange(e)}
                >
                  <MenuItem value="">
                    <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                      Select category
                    </span>
                  </MenuItem>
                  <MenuItem value="open">
                    <SelectSpan>OPEN</SelectSpan>
                  </MenuItem>
                  <MenuItem value="obc">
                    <SelectSpan>OBC</SelectSpan>
                  </MenuItem>
                  <MenuItem value="sc">
                    <SelectSpan>SC/ST</SelectSpan>
                  </MenuItem>
                  <MenuItem value="other">
                    <SelectSpan>OTHERS</SelectSpan>
                  </MenuItem>
                  <MenuItem value="dnd">
                    <SelectSpan>Don't wish to declare</SelectSpan>
                  </MenuItem>
                </Select>
                <FormHelperText>
                  {errors.affirmative_action_category?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}
          {is_domestic && (
            <Grid item xs={12} sm={6} md={4}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.registration_type)}
              >
                <VendorCardLabel>
                  Registration type (GST) <Super>*</Super>
                </VendorCardLabel>
                <Select
                  sx={{
                    fontFamily: "var(--font-family-reg)",
                    fontSize: "14px",
                  }}
                  defaultValue=""
                  displayEmpty={true}
                  IconComponent={() => (
                    <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                  )}
                  labelId="demo-simple-select-standard-label"
                  id="registration_type"
                  label="Registration_type"
                  name="registration_type"
                  {...register("registration_type", {
                    required: "Please select registration type",
                    value:
                      userdata.registration_type ||
                      userdata.gst_registration_type ||
                      "",
                  })}
                  error={Boolean(errors?.registration_type)}
                  value={
                    userdata.registration_type
                      ? userdata.registration_type
                      : userdata.gst_registration_type || ""
                  }
                  onChange={(e) => onChange(e)}
                >
                  <MenuItem value="">
                    <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                      Select registration type
                    </span>
                  </MenuItem>
                  <MenuItem value="regular">
                    <SelectSpan>Regular</SelectSpan>
                  </MenuItem>
                  <MenuItem value="composition">
                    <SelectSpan>Composition</SelectSpan>
                  </MenuItem>
                  {userdata?.registration_type === "unregistered" ? (
                    <MenuItem value="unregistered">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </Select>
                <FormHelperText>
                  {errors.registration_type?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Tax Identification number (TIN)</VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              InputProps={{
                disableUnderline: false,
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              placeholder="Do not enter GSTIN here"
              size="small"
              variant="standard"
              style={{ width: "100%", paddingTop: "3px" }}
              name="tax_identification_number"
              {...register("tax_identification_number", {
                required: false,
                value: userdata.tax_identification_number || "",
              })}
              value={userdata.tax_identification_number || ""}
              onChange={(e) => onChange(e)}
            />
          </Grid>
          {showWebsite && (
            <Grid item xs={12} sm={6} md={4}>
              <VendorCardLabel>Website</VendorCardLabel>
              <TextField
                sx={{
                  input: {
                    fontSize: "14px",
                    fontFamily: "var(--font-family-reg)",
                  },
                }}
                InputProps={{
                  disableUnderline: false,
                  disableInjectingGlobalStyles: true,
                }}
                InputLabelProps={{
                  disableAnimation: true,
                  disableInjectingGlobalStyles: true,
                }}
                placeholder="Enter website"
                size="small"
                variant="standard"
                style={{ width: "100%", paddingTop: "3px" }}
                name="website"
                {...register("website", {
                  required: false,
                  value: userdata.website || "",
                })}
                value={userdata.website || ""}
                onChange={(e) => onChange(e)}
              />
            </Grid>
          )}
          {showYearOfEstablishment && (
            <Grid item xs={12} sm={6} md={4}>
              <VendorCardLabel>Year of Establishment</VendorCardLabel>
              <TextField
                sx={{
                  input: {
                    fontSize: "14px",
                    fontFamily: "var(--font-family-reg)",
                  },
                }}
                InputProps={{
                  disableUnderline: false,
                  disableInjectingGlobalStyles: true,
                }}
                InputLabelProps={{
                  disableAnimation: true,
                  disableInjectingGlobalStyles: true,
                }}
                placeholder="Enter year of establishment"
                size="small"
                variant="standard"
                style={{ width: "100%", paddingTop: "3px" }}
                name="year_of_establishment"
                {...register("year_of_establishment", {
                  required: false,
                  value: userdata.year_of_establishment || "",
                  pattern: {
                    value: /^\d{4}$/,
                    message: "Year of establishment must be a 4-digit number",
                  },
                })}
                value={userdata.year_of_establishment || ""}
                onChange={(e) => onChange(e)}
                error={Boolean(errors?.year_of_establishment)}
                helperText={errors?.year_of_establishment?.message}
              />
            </Grid>
          )}
          {/* </Grid>
        <br />
        <Grid container spacing={3}> */}
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Annual turnover (in millions)</VendorCardLabel>
            <TextField
              sx={{
                input: {
                  fontSize: "14px",
                  fontFamily: "var(--font-family-reg)",
                },
              }}
              InputProps={{
                disableUnderline: false,
                disableInjectingGlobalStyles: true,
              }}
              InputLabelProps={{
                disableAnimation: true,
                disableInjectingGlobalStyles: true,
              }}
              size="small"
              variant="standard"
              style={{
                width: "100%",
                paddingTop: "3px",
                borderBottom: "1px solid lightgray",
              }}
              name="annual_turnover"
              placeholder="Enter annual turnover"
              {...register("annual_turnover", {
                required: false,
                pattern: {
                  value: /^-?\d*(\.\d{1,2})?$/,
                  message: "Invalid number format",
                },
                value: userdata.annual_turnover,
              })}
              value={userdata.annual_turnover || ""}
              error={errors?.annual_turnover}
              helperText={errors.annual_turnover?.message}
              onChange={async (e) => {
                onChange(e);
                await trigger("annual_turnover");
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <VendorCardLabel>Annual turnover (in Crores)</VendorCardLabel>
            <VendorDisabledFields>{annualCr}</VendorDisabledFields>
          </Grid>
        </Grid>
      </Container>
    </CardContent>
  );

  const isInitiallyMsmeApplicable =
    Boolean(userdata?.msme_register) &&
    userdata?.msme_register !== "others" &&
    userdata?.msme_register !== "null" &&
    userdata?.msme_register !== null &&
    userdata?.msme_register !== "";

  const msme_information = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle>
          <Grid container justifyContent={"space-between"}>
            <Grid item>MSME information</Grid>
            {isInitiallyMsmeApplicable && (
              <Grid
                item
                justifyContent={"end"}
                onClick={EditMSMEHandle}
                sx={{
                  cursor: "pointer",
                }}
              >
                <Tooltip title="Edit MSME Details">
                  <Edit color="info" fontSize="small" />
                </Tooltip>
              </Grid>
            )}
          </Grid>
        </VendorCardTitle>
        <VRSubTitle>For tax purposes</VRSubTitle>
        <Grid container spacing={1}>
          {is_domestic && (
            <Grid item xs={12} md={4}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.msme_register)}
              >
                <VendorCardLabel>
                  Are you MSME registered? <Super>*</Super>
                </VendorCardLabel>
                {isInitiallyMsmeApplicable ? (
                  <BankDisabledFields>Applicable</BankDisabledFields>
                ) : (
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    defaultValue=""
                    displayEmpty={true}
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    label="Are you MSME registered?"
                    name="msme_register"
                    value={mSME || ""}
                    {...register("msme_register", {
                      required: "Please select MSME category",
                    })}
                    onChange={(e) => handlemsme(e.target.value)}
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select value
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="others">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                )}

                <FormHelperText>{errors.msme_register?.message}</FormHelperText>
              </FormControl>
            </Grid>
          )}

          {isInitiallyMsmeApplicable ? (
            <>
              <Grid item xs={12} md={4}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>
                    MSME registration number <Super>*</Super>
                  </VendorCardLabel>
                  <BankDisabledFields>
                    {validatedMsmeData
                      ? validatedMsmeData.msme_registration_number
                      : userdata.msme_registration_number}
                  </BankDisabledFields>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>
                    Upload MSME Document<Super>*</Super>
                  </VendorCardLabel>
                  {msmeDoc !== "" ? (
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      <a
                        href={
                          msmeDoc instanceof File
                            ? URL.createObjectURL(msmeDoc)
                            : msmeDoc?.url || vendor_details?.msme_doc
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                            cursor: "pointer",
                          }}
                          label={msmeDoc.name || "MSME Document"}
                          value={msmeDoc.name || "MSME Document"}
                          name="chips"
                        />
                      </a>
                      <HighlightOffIcon
                        sx={{
                          color: "#4945FF",
                          paddingBottom: "2px",
                          cursor: "pointer",
                        }}
                        fontSize="medium"
                        onClick={(e) => setmsmeDoc("")}
                      />
                    </span>
                  ) : (
                    <label htmlFor="msme">
                      <Input
                        accept="*"
                        id="msme"
                        name="msme"
                        onChange={(e) => setmsmeDoc(e.target.files[0])}
                        type="file"
                      />
                      <StyledOutlineButton variant="outlined" component="span">
                        Upload
                      </StyledOutlineButton>
                    </label>
                  )}
                </FormControl>
              </Grid>
            </>
          ) : mSME !== "others" && mSME !== "" ? (
            <>
              <Grid item xs={12} md={4}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <VendorCardLabel>
                    MSME registration number <Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    InputProps={{
                      disableUnderline: false,
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    size="small"
                    variant="standard"
                    style={{
                      width: "100%",
                      paddingTop: "3px",
                      borderBottom: "1px solid lightgray",
                    }}
                    name="msme_registration_number"
                    placeholder="Enter MSME registration number"
                    {...register("msme_registration_number", {
                      required: false,
                    })}
                    value={msmenum || ""}
                    onChange={(e) => {
                      setMsmenum(e.target.value);
                      setCheckedMSME(false);
                      setValidatedMsmeData(null);
                      setValue("msme_registration_number", e.target.value, {
                        shouldValidate: true,
                      });
                    }}
                    error={Boolean(errors?.msme_registration_number)}
                    helperText={errors?.msme_registration_number?.message}
                  />
                </FormControl>
                {msmeLoading && (
                  <div style={{ marginTop: "5px" }}>
                    <span
                      style={{
                        fontSize: "13px",
                        color: "var(--button-color, #4945FF)",
                        fontStyle: "italic",
                      }}
                    >
                      Fetching details from Government portal...
                    </span>
                  </div>
                )}
              </Grid>

              <Grid item xs={12} md={4}>
                <LoadingButton
                  variant="contained"
                  loading={msmeLoading}
                  startIcon={checkedMSME ? <CheckCircleIcon /> : null}
                  sx={{
                    width: "160px",
                    marginTop: "10px",
                    backgroundColor: checkedMSME ? "#4caf50" : undefined,
                    "&:hover": checkedMSME
                      ? { backgroundColor: "#388e3c" }
                      : undefined,
                    pointerEvents: checkedMSME ? "none" : "auto",
                  }}
                  onClick={validateMsme}
                  disabled={!msmenum}
                >
                  {checkedMSME ? "Validated" : "Validate MSME"}
                </LoadingButton>
              </Grid>

              {checkedMSME && validatedMsmeData && (
                <Grid item xs={12}>
                  <br />
                  <MsmeComponents
                    msme_type={validatedMsmeData.msme_type}
                    enterprise_name={validatedMsmeData.enterprise_name}
                    enterprise_activity={validatedMsmeData.enterprise_activity}
                    classification_date={validatedMsmeData.classification_date}
                    classification_year={validatedMsmeData.classification_year}
                  />
                  <br />
                </Grid>
              )}

              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.msme)}
                >
                  <VendorCardLabel>
                    Upload MSME Document<Super>*</Super>
                  </VendorCardLabel>
                  {msmeDoc !== "" ? (
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      <a
                        href={
                          msmeDoc instanceof File
                            ? URL.createObjectURL(msmeDoc)
                            : msmeDoc?.url || vendor_details?.msme_doc
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                            cursor: "pointer",
                          }}
                          label={msmeDoc.name || "MSME Document"}
                          value={msmeDoc.name || "MSME Document"}
                          name="chips"
                        />
                      </a>
                      <HighlightOffIcon
                        sx={{
                          color: "#4945FF",
                          paddingBottom: "2px",
                          cursor: "pointer",
                        }}
                        fontSize="medium"
                        onClick={(e) => setmsmeDoc("")}
                      />
                    </span>
                  ) : (
                    <label htmlFor="msme">
                      <Input
                        {...register("msme", {
                          required: "Please upload MSME certificate copy",
                        })}
                        accept="*"
                        id="msme"
                        name="msme"
                        onChange={(e) => setmsmeDoc(e.target.files[0])}
                        type="file"
                      />
                      <StyledOutlineButton variant="outlined" component="span">
                        Upload
                      </StyledOutlineButton>
                    </label>
                  )}
                  {msmeDoc === "" ? (
                    <FormHelperText>{errors.msme?.message}</FormHelperText>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Grid>
            </>
          ) : null}
        </Grid>
        <br />

        {isInitiallyMsmeApplicable &&
        (validatedMsmeData
          ? validatedMsmeData.msme_type
          : userdata.msme_type) !== "others" &&
        (validatedMsmeData
          ? validatedMsmeData.msme_type
          : userdata.msme_type) ? (
          <>
            <MsmeComponents
              msme_type={
                validatedMsmeData
                  ? validatedMsmeData.msme_type
                  : userdata?.msme_type
              }
              enterprise_name={
                validatedMsmeData
                  ? validatedMsmeData.enterprise_name
                  : userdata?.enterprise_name
              }
              enterprise_activity={
                validatedMsmeData
                  ? validatedMsmeData.enterprise_activity
                  : userdata?.enterprise_activity
              }
              classification_date={
                validatedMsmeData
                  ? validatedMsmeData.classification_date
                  : userdata?.classification_date
              }
              classification_year={
                validatedMsmeData
                  ? validatedMsmeData.classification_year
                  : userdata?.classification_year
              }
            />
          </>
        ) : null}
      </Container>
    </CardContent>
  );

  const registration_information = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle>Registration Information</VendorCardTitle>
        <VRSubTitle>For registration and verification purposes</VRSubTitle>{" "}
        <Grid container spacing={2}>
          {showCinValidation && (
            <Grid
              container
              spacing={2}
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12}>
                <VendorCardTitle
                  style={{
                    paddingBottom: "5px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  CIN Number / Registration ID
                </VendorCardTitle>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.cin_applicable)}
                >
                  <VendorCardLabel>
                    Do you have a CIN Number / Registration ID? <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    value={
                      isCinForced
                        ? "Applicable"
                        : watchedCinApplicable || userdata.cin_applicable || "Not Applicable"
                    }
                    disabled={isCinForced}
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id="cin_applicable"
                    name="cin_applicable"
                    {...register("cin_applicable")}
                    onChange={(e) => {
                      setValue("cin_applicable", e.target.value, { shouldValidate: true });
                      setUserdata((prev) => ({ ...prev, cin_applicable: e.target.value }));
                    }}
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Option
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Not Applicable">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.cin_applicable?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {resolvedCinApplicable === "Applicable" && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      CIN Number / Registration ID <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      placeholder="Enter CIN / Registration ID"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="cin_number"
                      value={userdata.cin_number || ""}
                      {...register("cin_number", {
                        pattern: {
                          value:
                            /^[LUlu][0-9]{5}[A-Za-z]{2}[0-9]{4}[A-Za-z]{3}[0-9]{6}$/,
                          message:
                            "Invalid CIN number (21-digit alphanumeric starting with L or U)",
                        },
                      })}
                      onChange={(e) => onChange(e)}
                      error={Boolean(errors?.cin_number)}
                      helperText={errors?.cin_number?.message}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      error={Boolean(cinError)}
                      style={{ width: "100%" }}
                    >
                      <VendorCardLabel>
                        Upload CIN copy <Super>*</Super>
                      </VendorCardLabel>
                      {cinDoc !== "" ? (
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          {cinDoc.url ? (
                            <a
                              href={cinDoc.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Chip
                                style={{
                                  width: "150px",
                                  color: "#4945FF",
                                  margin: "5px",
                                  borderRadius: "5px",
                                  border: "1px solid #D9D8FF",
                                  background: "#F0F0FF",
                                }}
                                label={cinDoc.name}
                                value={cinDoc.name}
                              />
                            </a>
                          ) : (
                            <Chip
                              style={{
                                width: "150px",
                                color: "#4945FF",
                                margin: "5px",
                                borderRadius: "5px",
                                border: "1px solid #D9D8FF",
                                background: "#F0F0FF",
                              }}
                              label={cinDoc.name}
                              value={cinDoc.name}
                            />
                          )}
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => setCinDoc("")}
                          />
                        </span>
                      ) : (
                        <label htmlFor="cin_doc_upload">
                          <Input
                            accept="*"
                            id="cin_doc_upload"
                            name="cin_doc_upload"
                            onChange={(e) => {
                              setCinDoc(e.target.files[0]);
                              setCinError("");
                            }}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                            style={{ marginTop: "5px" }}
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {cinError && <FormHelperText>{cinError}</FormHelperText>}
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {showIecRegistration && (
            <Grid
              container
              spacing={2}
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12}>
                <VendorCardTitle
                  style={{
                    paddingBottom: "5px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Import Export Code (IEC)
                </VendorCardTitle>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.iec_applicable)}
                >
                  <VendorCardLabel>
                    Do you have an Import Export Code? <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    value={userdata.iec_applicable || ""}
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id="iec_applicable"
                    name="iec_applicable"
                    {...register("iec_applicable", {
                      value: userdata.iec_applicable || "",
                    })}
                    onChange={(e) => onChange(e)}
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Option
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Not Applicable">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.iec_applicable?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {watchedIecApplicable === "Applicable" && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      Import Export Code <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      placeholder="Enter Import Export Code"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="iec_number"
                      value={userdata.iec_number || ""}
                      {...register("iec_number", {
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message:
                            "Invalid Import Export Code (10-digit number)",
                        },
                      })}
                      onChange={(e) => onChange(e)}
                      error={Boolean(errors?.iec_number)}
                      helperText={errors?.iec_number?.message}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      error={Boolean(iecError)}
                      style={{ width: "100%" }}
                    >
                      <VendorCardLabel>
                        Upload Import Export Code <Super>*</Super>
                      </VendorCardLabel>
                      {iecDoc !== "" ? (
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          {iecDoc.url ? (
                            <a
                              href={iecDoc.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Chip
                                style={{
                                  width: "150px",
                                  color: "#4945FF",
                                  margin: "5px",
                                  borderRadius: "5px",
                                  border: "1px solid #D9D8FF",
                                  background: "#F0F0FF",
                                }}
                                label={iecDoc.name}
                                value={iecDoc.name}
                              />
                            </a>
                          ) : (
                            <Chip
                              style={{
                                width: "150px",
                                color: "#4945FF",
                                margin: "5px",
                                borderRadius: "5px",
                                border: "1px solid #D9D8FF",
                                background: "#F0F0FF",
                              }}
                              label={iecDoc.name}
                              value={iecDoc.name}
                            />
                          )}
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => setIecDoc("")}
                          />
                        </span>
                      ) : (
                        <label htmlFor="iec_doc_upload">
                          <Input
                            accept="*"
                            id="iec_doc_upload"
                            name="iec_doc_upload"
                            onChange={(e) => {
                              setIecDoc(e.target.files[0]);
                              setIecError("");
                            }}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                            style={{ marginTop: "5px" }}
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {iecError && <FormHelperText>{iecError}</FormHelperText>}
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {showFactoryRegistration && (
            <Grid
              container
              spacing={2}
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12}>
                <VendorCardTitle
                  style={{
                    paddingBottom: "5px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Factory License
                </VendorCardTitle>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.factory_license_applicable)}
                >
                  <VendorCardLabel>
                    Do you have a Factory License? <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    value={userdata.factory_license_applicable || ""}
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id="factory_license_applicable"
                    name="factory_license_applicable"
                    {...register("factory_license_applicable", {
                      value: userdata.factory_license_applicable || "",
                    })}
                    onChange={(e) => onChange(e)}
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Option
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Not Applicable">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.factory_license_applicable?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {watchedFactoryApplicable === "Applicable" && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      Factory License Number <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      placeholder="Enter Factory License Number"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="factory_license_number"
                      value={userdata.factory_license_number || ""}
                      {...register("factory_license_number", {
                        pattern: {
                          value: /^[a-zA-Z0-9\/-]{3,30}$/,
                          message:
                            "Invalid Factory License number (3-30 alphanumeric characters)",
                        },
                      })}
                      onChange={(e) => onChange(e)}
                      error={Boolean(errors?.factory_license_number)}
                      helperText={errors?.factory_license_number?.message}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      error={Boolean(factoryError)}
                      style={{ width: "100%" }}
                    >
                      <VendorCardLabel>
                        Upload Factory License <Super>*</Super>
                      </VendorCardLabel>
                      {factoryDoc !== "" ? (
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          {factoryDoc.url ? (
                            <a
                              href={factoryDoc.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Chip
                                style={{
                                  width: "150px",
                                  color: "#4945FF",
                                  margin: "5px",
                                  borderRadius: "5px",
                                  border: "1px solid #D9D8FF",
                                  background: "#F0F0FF",
                                }}
                                label={factoryDoc.name}
                                value={factoryDoc.name}
                              />
                            </a>
                          ) : (
                            <Chip
                              style={{
                                width: "150px",
                                color: "#4945FF",
                                margin: "5px",
                                borderRadius: "5px",
                                border: "1px solid #D9D8FF",
                                background: "#F0F0FF",
                              }}
                              label={factoryDoc.name}
                              value={factoryDoc.name}
                            />
                          )}
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => setFactoryDoc("")}
                          />
                        </span>
                      ) : (
                        <label htmlFor="factory_doc_upload">
                          <Input
                            accept="*"
                            id="factory_doc_upload"
                            name="factory_doc_upload"
                            onChange={(e) => {
                              setFactoryDoc(e.target.files[0]);
                              setFactoryError("");
                            }}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                            style={{ marginTop: "5px" }}
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {factoryError && (
                        <FormHelperText>{factoryError}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {showEprRegistration && (
            <Grid
              container
              spacing={2}
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12}>
                <VendorCardTitle
                  style={{
                    paddingBottom: "5px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  EPR Certificate
                </VendorCardTitle>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.epr_applicable)}
                >
                  <VendorCardLabel>
                    Do you have an EPR Number? <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    value={userdata.epr_applicable || ""}
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id="epr_applicable"
                    name="epr_applicable"
                    {...register("epr_applicable", {
                      value: userdata.epr_applicable || "",
                    })}
                    onChange={(e) => onChange(e)}
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Option
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Not Applicable">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.epr_applicable?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {watchedEprApplicable === "Applicable" && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      EPR Number <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      placeholder="Enter EPR Number"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="epr_number"
                      value={userdata.epr_number || ""}
                      {...register("epr_number", {
                        pattern: {
                          value: /^[a-zA-Z0-9\/-]{5,50}$/,
                          message: "Invalid EPR number (5-50 characters)",
                        },
                      })}
                      onChange={(e) => onChange(e)}
                      error={Boolean(errors?.epr_number)}
                      helperText={errors?.epr_number?.message}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      error={Boolean(eprError)}
                      style={{ width: "100%" }}
                    >
                      <VendorCardLabel>
                        Upload EPR Certificate <Super>*</Super>
                      </VendorCardLabel>
                      {eprDoc !== "" ? (
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          {eprDoc.url ? (
                            <a
                              href={eprDoc.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Chip
                                style={{
                                  width: "150px",
                                  color: "#4945FF",
                                  margin: "5px",
                                  borderRadius: "5px",
                                  border: "1px solid #D9D8FF",
                                  background: "#F0F0FF",
                                }}
                                label={eprDoc.name}
                                value={eprDoc.name}
                              />
                            </a>
                          ) : (
                            <Chip
                              style={{
                                width: "150px",
                                color: "#4945FF",
                                margin: "5px",
                                borderRadius: "5px",
                                border: "1px solid #D9D8FF",
                                background: "#F0F0FF",
                              }}
                              label={eprDoc.name}
                              value={eprDoc.name}
                            />
                          )}
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => setEprDoc("")}
                          />
                        </span>
                      ) : (
                        <label htmlFor="epr_doc_upload">
                          <Input
                            accept="*"
                            id="epr_doc_upload"
                            name="epr_doc_upload"
                            onChange={(e) => {
                              setEprDoc(e.target.files[0]);
                              setEprError("");
                            }}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                            style={{ marginTop: "5px" }}
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {eprError && <FormHelperText>{eprError}</FormHelperText>}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      EPR Certificate Expiry <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      type="date"
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="epr_expiry"
                      value={userdata.epr_expiry || ""}
                      {...register("epr_expiry")}
                      onChange={(e) => onChange(e)}
                      error={Boolean(errors?.epr_expiry)}
                      helperText={errors?.epr_expiry?.message}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          )}

          {showPollutionRegistration && (
            <Grid
              container
              spacing={2}
              item
              xs={12}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12}>
                <VendorCardTitle
                  style={{
                    paddingBottom: "5px",
                    fontSize: "16px",
                    fontWeight: "600",
                  }}
                >
                  Pollution Control Certificate
                </VendorCardTitle>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  variant="standard"
                  style={{ width: "100%" }}
                  error={Boolean(errors?.pollution_control_applicable)}
                >
                  <VendorCardLabel>
                    Do you have a Pollution Control Certificate?{" "}
                    <Super>*</Super>
                  </VendorCardLabel>
                  <Select
                    sx={{
                      fontFamily: "var(--font-family-reg)",
                      fontSize: "14px",
                    }}
                    displayEmpty
                    value={userdata.pollution_control_applicable || ""}
                    IconComponent={() => (
                      <ExpandMoreIcon style={{ color: "#A5A5BA" }} />
                    )}
                    id="pollution_control_applicable"
                    name="pollution_control_applicable"
                    {...register("pollution_control_applicable", {
                      value: userdata.pollution_control_applicable || "",
                    })}
                    onChange={(e) => onChange(e)}
                  >
                    <MenuItem value="">
                      <span style={{ fontSize: "14px", color: "#A5A5BA" }}>
                        Select Option
                      </span>
                    </MenuItem>
                    <MenuItem value="Applicable">
                      <SelectSpan>Applicable</SelectSpan>
                    </MenuItem>
                    <MenuItem value="Not Applicable">
                      <SelectSpan>Not Applicable</SelectSpan>
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {errors.pollution_control_applicable?.message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              {watchedPollutionApplicable === "Applicable" && (
                <>
                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      Pollution Control Certificate Number <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      placeholder="Enter Pollution Control Certificate Number"
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="pollution_control_number"
                      value={userdata.pollution_control_number || ""}
                      {...register("pollution_control_number", {
                        pattern: {
                          value: /^[a-zA-Z0-9\/-]{5,50}$/,
                          message:
                            "Invalid Pollution Control number (5-50 characters)",
                        },
                      })}
                      onChange={(e) => onChange(e)}
                      error={Boolean(errors?.pollution_control_number)}
                      helperText={errors?.pollution_control_number?.message}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      error={Boolean(pollutionError)}
                      style={{ width: "100%" }}
                    >
                      <VendorCardLabel>
                        Upload Pollution Control Certificate <Super>*</Super>
                      </VendorCardLabel>
                      {pollutionDoc !== "" ? (
                        <span
                          style={{
                            color: "#4945FF",
                            fontSize: "13px",
                            fontFamily: "var(--font-family-reg)",
                          }}
                        >
                          {pollutionDoc.url ? (
                            <a
                              href={pollutionDoc.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Chip
                                style={{
                                  width: "150px",
                                  color: "#4945FF",
                                  margin: "5px",
                                  borderRadius: "5px",
                                  border: "1px solid #D9D8FF",
                                  background: "#F0F0FF",
                                }}
                                label={pollutionDoc.name}
                                value={pollutionDoc.name}
                              />
                            </a>
                          ) : (
                            <Chip
                              style={{
                                width: "150px",
                                color: "#4945FF",
                                margin: "5px",
                                borderRadius: "5px",
                                border: "1px solid #D9D8FF",
                                background: "#F0F0FF",
                              }}
                              label={pollutionDoc.name}
                              value={pollutionDoc.name}
                            />
                          )}
                          <HighlightOffIcon
                            sx={{
                              color: "#4945FF",
                              paddingBottom: "2px",
                              cursor: "pointer",
                            }}
                            fontSize="medium"
                            onClick={(e) => setPollutionDoc("")}
                          />
                        </span>
                      ) : (
                        <label htmlFor="pollution_doc_upload">
                          <Input
                            accept="*"
                            id="pollution_doc_upload"
                            name="pollution_doc_upload"
                            onChange={(e) => {
                              setPollutionDoc(e.target.files[0]);
                              setPollutionError("");
                            }}
                            type="file"
                          />
                          <StyledOutlineButton
                            variant="outlined"
                            component="span"
                            style={{ marginTop: "5px" }}
                          >
                            Upload
                          </StyledOutlineButton>
                        </label>
                      )}
                      {pollutionError && (
                        <FormHelperText>{pollutionError}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <VendorCardLabel>
                      Pollution Control Expiry <Super>*</Super>
                    </VendorCardLabel>
                    <TextField
                      type="date"
                      sx={{
                        input: {
                          fontSize: "14px",
                          fontFamily: "var(--font-family-reg)",
                        },
                      }}
                      InputProps={{ disableUnderline: false }}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      variant="standard"
                      style={{ width: "100%", paddingTop: "3px" }}
                      name="pollution_control_expiry"
                      value={userdata.pollution_control_expiry || ""}
                      {...register("pollution_control_expiry")}
                      onChange={(e) => onChange(e)}
                      error={Boolean(errors?.pollution_control_expiry)}
                      helperText={errors?.pollution_control_expiry?.message}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          )}
        </Grid>
      </Container>
    </CardContent>
  );

  /* const documents = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle style={{ marginBottom: "3px" }}>
          Documents
        </VendorCardTitle>
        <VRSubTitle>
          <span>
            <img src={info} alt="icon" />
          </span>
          {"\u00A0"}
          {"\u00A0"}
          TDS may be deducted at higher rates in case of incorrect or missing
          PAN information as per IT rules
        </VRSubTitle>
        {is_domestic === true && (
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            style={{ marginTop: "10px" }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels>
                  Upload PAN copy<Super>*</Super>
                </DocumentLabels>
              </span>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.pan)}
              >
                {panDoc !== "" ? (
                  <>
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      <a
                        href={`${vendor_details.Documents?.[0]?.pan_image}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={panDoc.name}
                          value={panDoc.name}
                          name="chips"
                        />
                      </a>
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setPanDoc("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="pan">
                    <Input
                      {...register("pan", {
                        required: "Please upload PAN copy",
                      })}
                      accept="*"
                      id="pan"
                      onChange={(e) => setPanDoc(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
                {panDoc === "" ? (
                  <FormHelperText>{errors.pan?.message}</FormHelperText>
                ) : (
                  ""
                )}
              </FormControl>
            </Grid>
          </Grid>
        )}

        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          style={{ marginTop: "10px" }}
        >
          <Grid item xs={6}>
            <span variant="outlined" component="span" style={{ width: "50%" }}>
              <DocumentLabels>
                <>
                  {isVendorTerms ? "VAD" : "Vendor information form"}
                  {isVendorApproval || isVendorTerms ? (
                    <Super>*</Super>
                  ) : (
                    ""
                  )}
                </>
              </DocumentLabels>
              {isVendorApproval ? (
                <CustomDocumentLink
                  style={{ fontSize: "0.8rem" }}
                  href={VRF_vishakha}
                >
                  <FileDownload fontSize="small" color="primary" />
                  {"\u00A0"} Download Form
                </CustomDocumentLink>
              ) : (
                ""
              )}
            </span>
          </Grid>
          <Grid item xs={6}>
            <FormControl
              variant="standard"
              style={{ width: "100%" }}
              error={Boolean(errors?.dealerName)}
            >
              {dealer !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <a
                      href={`${vendor_details.Documents?.[0].dealer_authorization_image}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={dealer.name}
                        value={dealer.name}
                        name="chips"
                      />
                    </a>
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setDealer("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="dealer">
                  <Input
                    {...register("dealerName", {
                      required:
                        (isVendorApproval || isVendorTerms) &&
                        !vendor_details?.Documents?.[0]?.dealer_authorization_image
                          ? "Please upload vendor form copy"
                          : false,
                    })}
                    accept="*"
                    id="dealer"
                    name="dealer"
                    onChange={(e) => setDealer(e.target.files[0])}
                    type="file"
                  />

                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{dealer.name}</span>
                </label>
              )}
              {dealer === "" ? (
                <FormHelperText>{errors.dealerName?.message}</FormHelperText>
              ) : (
                ""
              )}
            </FormControl>
          </Grid>
        </Grid>

        {!isVendorApproval && (
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            style={{ marginTop: "10px" }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels> Upload TIN certificate</DocumentLabels>
              </span>
            </Grid>
            <Grid item xs={6}>
              {tin !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <a
                      href={`${vendor_details.Documents?.[0].tin_certificate_image}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={tin.name}
                        value={tin.name}
                        name="chips"
                      />
                    </a>
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setTin("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="tin_doc">
                  <Input
                    accept="*"
                    id="tin_doc"
                    name="tin_doc"
                    onChange={(e) => setTin(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{tin.name}</span>
                </label>
              )}
            </Grid>
          </Grid>
        )}

        {!isVendorApproval && (
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            style={{ marginTop: "10px" }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels>
                  Upload ISO, RSDO and any additional certificate
                </DocumentLabels>
              </span>
            </Grid>
            <Grid item xs={6}>
              {iso !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <a
                      href={`${vendor_details.Documents?.[0].iso_or_rsdo_or_any_image}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={iso.name}
                        value={iso.name}
                        name="chips"
                      />
                    </a>
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => setIso("")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="iso_doc">
                  <Input
                    accept="*"
                    id="iso_doc"
                    name="iso_doc"
                    onChange={(e) => setIso(e.target.files[0])}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{iso.name}</span>
                </label>
              )}
            </Grid>
          </Grid>
        )}

        {!isVendorApproval && (
          <>
            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              style={{ marginTop: "10px" }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload COA / Test Certificate</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {coa !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      {coa.url || vendor_details.Documents?.[0]?.coa_test_certificate_image ? (
                        <a
                          href={coa.url || vendor_details.Documents?.[0]?.coa_test_certificate_image}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={coa.name}
                            value={coa.name}
                          />
                        </a>
                      ) : (
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={coa.name}
                          value={coa.name}
                        />
                      )}
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setCoa("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="coa_doc">
                    <Input
                      accept="*"
                      id="coa_doc"
                      name="coa_doc"
                      onChange={(e) => setCoa(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              style={{ marginTop: "10px" }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload Quality Audit Report</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {qualityAudit !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      {qualityAudit.url || vendor_details.Documents?.[0]?.quality_audit_report_image ? (
                        <a
                          href={qualityAudit.url || vendor_details.Documents?.[0]?.quality_audit_report_image}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={qualityAudit.name}
                            value={qualityAudit.name}
                          />
                        </a>
                      ) : (
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={qualityAudit.name}
                          value={qualityAudit.name}
                        />
                      )}
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setQualityAudit("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="quality_audit_doc">
                    <Input
                      accept="*"
                      id="quality_audit_doc"
                      name="quality_audit_doc"
                      onChange={(e) => setQualityAudit(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              style={{ marginTop: "10px" }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload Hazardous Material Declaration</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {hazardous !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      {hazardous.url || vendor_details.Documents?.[0]?.hazardous_material_declaration_image ? (
                        <a
                          href={hazardous.url || vendor_details.Documents?.[0]?.hazardous_material_declaration_image}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={hazardous.name}
                            value={hazardous.name}
                          />
                        </a>
                      ) : (
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={hazardous.name}
                          value={hazardous.name}
                        />
                      )}
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setHazardous("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="hazardous_doc">
                    <Input
                      accept="*"
                      id="hazardous_doc"
                      name="hazardous_doc"
                      onChange={(e) => setHazardous(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              style={{ marginTop: "10px" }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload SDS / MSDS Availability</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {sds !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      {sds.url || vendor_details.Documents?.[0]?.sds_msds_availability_image ? (
                        <a
                          href={sds.url || vendor_details.Documents?.[0]?.sds_msds_availability_image}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={sds.name}
                            value={sds.name}
                          />
                        </a>
                      ) : (
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={sds.name}
                          value={sds.name}
                        />
                      )}
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setSds("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="sds_doc">
                    <Input
                      accept="*"
                      id="sds_doc"
                      name="sds_doc"
                      onChange={(e) => setSds(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              style={{ marginTop: "10px" }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload UN Certificates</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {unCert !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      {unCert.url || vendor_details.Documents?.[0]?.un_certificates_image ? (
                        <a
                          href={unCert.url || vendor_details.Documents?.[0]?.un_certificates_image}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={unCert.name}
                            value={unCert.name}
                          />
                        </a>
                      ) : (
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={unCert.name}
                          value={unCert.name}
                        />
                      )}
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={(e) => setUnCert("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="un_cert_doc">
                    <Input
                      accept="*"
                      id="un_cert_doc"
                      name="un_cert_doc"
                      onChange={(e) => setUnCert(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>

            <br />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              style={{ marginTop: "10px" }}
            >
              <Grid item xs={6}>
                <span variant="outlined" component="span" style={{ width: "50%" }}>
                  <DocumentLabels>Upload Vendor Site Images</DocumentLabels>
                </span>
              </Grid>
              <Grid item xs={6}>
                {vendorSite !== "" ? (
                  <>
                    <span style={{ color: "#4945FF", fontSize: "13px", fontFamily: "var(--font-family-reg)" }}>
                      {vendorSite.url ? (
                        <a
                          href={vendorSite.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={vendorSite.name}
                            value={vendorSite.name}
                          />
                        </a>
                      ) : (
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={vendorSite.name}
                          value={vendorSite.name}
                        />
                      )}
                      <HighlightOffIcon
                        sx={{ color: "#4945FF", paddingBottom: "2px", cursor: "pointer" }}
                        fontSize="medium"
                        onClick={(e) => setVendorSite("")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="vendor_site_doc">
                    <Input
                      accept="*"
                      id="vendor_site_doc"
                      name="vendor_site_doc"
                      onChange={(e) => setVendorSite(e.target.files[0])}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>
          </>
        )}

        {newDocs.map((item, index) => (
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            key={index}
            style={{ marginTop: "10px" }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels style={{ marginTop: "10px" }}>
                  {index === 0 ? "Upload Any Documents" : ""}
                </DocumentLabels>
              </span>
            </Grid>
            {anyDocs[index] && anyDocs[index] !== "" ? (
              <Grid item xs={6}>
                <FormControl variant="standard" style={{ width: "100%" }}>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    <a
                      href={`${anyDocs[index].path ? anyDocs[index].path : ""}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Chip
                        style={{
                          width: "150px",
                          color: "#4945FF",
                          margin: "5px",
                          borderRadius: "5px",
                          border: "1px solid #D9D8FF",
                          background: "#F0F0FF",
                        }}
                        label={anyDocs[index].name}
                        value={anyDocs[index].name}
                        name="chips"
                      />
                    </a>
                    <HighlightOffIcon
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={(e) => handleclearDoc(e, index)}
                    />
                  </span>
                </FormControl>
              </Grid>
            ) : (
              <>
                <Grid item xs={3}>
                  <FormControl variant="standard" style={{ width: "100%" }}>
                    <label>
                      <Input
                        accept="*"
                        id={`anyDocs${index}`}
                        onChange={(e) => handlechangeDoc(e, index)}
                        type="file"
                      />
                      <StyledOutlineButton
                        variant="outlined"
                        component="span"
                      >
                        Upload
                      </StyledOutlineButton>
                    </label>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  {index > 0 ? (
                    <CustomButton
                      className="invoiceErrbutn"
                      color="error"
                      variant="outlined"
                      size="small"
                      onClick={(e) => handleRemove(e, index)}
                      style={{ marginTop: "10px " }}
                    >
                      Remove
                    </CustomButton>
                  ) : (
                    ""
                  )}
                </Grid>
              </>
            )}
          </Grid>
        ))}

        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          style={{ marginTop: "10px" }}
        >
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <CustomButton
              size="small"
              color="primary"
              variant="outlined"
              onClick={handleOnClick}
              className="invoiceErrbutn"
            >
              Add Document
            </CustomButton>
          </Grid>
        </Grid>
      </Container>
    </CardContent>
  ); */
  const major_customer_list_ui = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle style={{ marginBottom: "10px" }}>
          Major Customer List
        </VendorCardTitle>
        <VRSubTitle style={{ marginBottom: "15px" }}>
          Provide the names of your major customers
        </VRSubTitle>
        <Grid container spacing={2}>
          {majorCustomers.map((customer, index) => (
            <Grid
              container
              item
              spacing={1}
              alignItems="center"
              key={index}
              xs={12}
            >
              <Grid item xs={10} sm={6} md={4}>
                <VendorCardLabel>Customer Name {index + 1}</VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{ disableUnderline: false }}
                  placeholder="Enter Customer Name"
                  size="small"
                  variant="standard"
                  style={{ width: "100%", paddingTop: "3px" }}
                  value={customer}
                  onChange={(e) => handleCustomerChange(index, e.target.value)}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={1} style={{ marginTop: "15px" }}>
                <HighlightOffIcon
                  sx={{ color: "#d32f2f", cursor: "pointer" }}
                  onClick={() => handleRemoveCustomer(index)}
                />
              </Grid>
            </Grid>
          ))}
          <Grid item xs={12} style={{ marginTop: "15px" }}>
            <CustomButton
              size="small"
              color="primary"
              variant="outlined"
              onClick={handleAddCustomer}
              className="invoiceErrbutn"
            >
              {" "}
              + Add more{" "}
            </CustomButton>
          </Grid>
        </Grid>
      </Container>
    </CardContent>
  );

  const additional_info = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle>Additional information</VendorCardTitle>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={6} md={9}>
            <VRSubTitle>
              Areas of business interest. Select all that apply and wait for the
              HSN/SAC code to appear below
            </VRSubTitle>
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <VRSubTitle style={{ textAlign: "right" }}>
              <a
                rel="noopener noreferrer"
                href={`${vendorCompany?.domain_url}/api/hsn_codes`}
                style={{
                  textDecoration: "none",
                  whiteSpace: "nowrap",
                  color: "#4059e5",
                }}
                target="_blank"
              >
                Download Codesheet
              </a>
            </VRSubTitle>
          </Grid>
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item md={3} xs={12}>
            <AdditionalDetailsCard>
              <CardContent style={{ overflow: "auto", height: "272px" }}>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  // style={{ marginTop: "36px" }}
                >
                  <Grid
                    style={checkedType === "2" ? radioStyles.selectRadio : null}
                  >
                    <CustomFormSelection
                      value="2"
                      control={<Radio style={{ visibility: "hidden" }} />}
                      label="Goods"
                      style={{
                        textAlign: "-23px",
                      }}
                      onChange={(e) => handleadditionalChange(e, "2")}
                      className="goods"
                    />

                    {checkedType === "2" ? (
                      <ArrowRightIcon
                        style={{
                          textAlign: "center",
                          float: "right",
                          marginTop: "7px",
                          marginLeft: "-32px",
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid
                    style={checkedType === "1" ? radioStyles.selectRadio : null}
                  >
                    <CustomFormSelection
                      value="1"
                      control={<Radio style={{ visibility: "hidden" }} />}
                      label="Services"
                      /*  style={{ textAlign: "-25px" }} */
                      onChange={(e) => handleadditionalChange(e, "1")}
                      className="goods"
                    />
                    <span
                      style={{
                        textAlign: "center",
                        float: "right",
                        marginTop: "7px",
                        marginLeft: "-32px",
                      }}
                    >
                      {checkedType === "1" ? <ArrowRightIcon /> : ""}
                    </span>
                  </Grid>
                </RadioGroup>
              </CardContent>
            </AdditionalDetailsCard>
          </Grid>
          {isLoading ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : code_filtered ? (
            <Grid item md={3} xs={12} style={{ display: catdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => handleSearchChange(e)}
                    placeholder="Search by description"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {code_filtered.length ? (
                      code_filtered.map((item, index) => (
                        <Grid
                          key={index}
                          style={
                            subCategory === `${item.category}`
                              ? radioStyles1.selectRadio
                              : null
                          }
                        >
                          <Tooltip
                            title={item.categortDescription}
                            placement="right"
                          >
                            <CustomFormControl
                              style={{
                                fontSize: "12px",
                              }}
                              label={item.categortDescription}
                              value={item.category}
                              control={
                                <Radio style={{ visibility: "hidden" }} />
                              }
                              onChange={(e) =>
                                handlecategoryChange(e, `${item.category}`)
                              }
                              className="goods1"
                            />
                          </Tooltip>
                        </Grid>
                      ))
                    ) : (
                      <VendorCardLabel>
                        <br />
                        <InfoIcon
                          sx={{
                            fill: "grey",
                            height: "18px",
                            width: "18px",
                          }}
                        />
                        {"There are no categeories to display"}
                      </VendorCardLabel>
                    )}
                  </RadioGroup>
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}

          {isLoadingsub ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : sub_filtered ? (
            <Grid item md={3} xs={12} style={{ display: subcatdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => setSearchsub(e.target.value)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by code"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {sub_filtered.length ? (
                      sub_filtered.map((item, index) => (
                        <Grid
                          key={index}
                          style={
                            itemcodes === `${item.subCategory}`
                              ? radioStyles1.selectRadio
                              : null
                          }
                        >
                          <Tooltip
                            title={item.subCategoryDescription}
                            placement="right"
                          >
                            <CustomFormControl
                              style={{
                                fontSize: "12px",
                              }}
                              label={
                                item.subCategory +
                                " - " +
                                item.subCategoryDescription
                              }
                              value={item.subCategory}
                              control={
                                <Radio style={{ visibility: "hidden" }} />
                              }
                              onChange={(e) =>
                                handlesubcategoryChange(
                                  e,
                                  `${item.subCategory}`,
                                )
                              }
                              className="goods1"
                            />
                          </Tooltip>
                        </Grid>
                      ))
                    ) : (
                      <VendorCardLabel>
                        <br />
                        <InfoIcon
                          sx={{
                            fill: "grey",
                            height: "18px",
                            width: "18px",
                          }}
                        />
                        {"There are no categeories to display"}
                      </VendorCardLabel>
                    )}
                  </RadioGroup>
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}

          {isLoadingitem ? (
            <Grid item md={3} xs={12}>
              <AdditionalDetailsCard>
                <CardContent style={{ overflow: "auto", height: "272px" }}>
                  <Skeleton count={7} />
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : item_filtered ? (
            <Grid item md={3} xs={12} style={{ display: itemcatdisplay }}>
              <AdditionalDetailsCard>
                <div style={{ height: "50px", backgroundColor: " #F7F9FC" }}>
                  <TextField
                    id="Search"
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                    className="search_for_add_info"
                    variant="standard"
                    onChange={(e) => setSearchitem(e.target.value)}
                    style={{ fontSize: "12px !important" }}
                    placeholder="Search by code"
                  />
                </div>
                <CardContent
                  style={{
                    paddingTop: "5px",
                    overflow: "auto",
                    height: "222px",
                  }}
                >
                  {item_filtered.length ? (
                    item_filtered.map((item, index) => (
                      <FormGroup
                        key={item.id}
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                      >
                        <Grid key={item.id}>
                          <Tooltip
                            title={item.itemDescription}
                            placement="bottom"
                          >
                            <CustomFormControl
                              multiple
                              key={item.id}
                              style={{ fontSize: "12px" }}
                              value={item.item}
                              control={
                                <Checkbox
                                  sx={{
                                    color: "lightgray",
                                    "&.Mui-checked": {
                                      color: "#4059e5",
                                    },
                                  }}
                                  checked={personName.includes(`${item.item}`)}
                                />
                              }
                              label={item.item + " - " + item.itemDescription}
                              className="itemName"
                              onChange={(e) =>
                                handleCheckChange(e, `${item.item}`)
                              }
                            />
                          </Tooltip>
                        </Grid>
                      </FormGroup>
                    ))
                  ) : (
                    <VendorCardLabel>
                      <br />
                      <InfoIcon
                        sx={{
                          fill: "grey",
                          height: "18px",
                          width: "18px",
                        }}
                      />
                      {"There are no sub categeories to display"}
                    </VendorCardLabel>
                  )}
                </CardContent>
              </AdditionalDetailsCard>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        <br />
        <VendorCardTitle style={{ paddingBottom: "0px" }}>
          Selected HSN/SAC Codes
        </VendorCardTitle>
        <FormControl>
          <Stack direction="row" spacing={4}>
            <Grid item xs={2}>
              <VendorCardBlankTitle
                style={{ marginTop: "0", marginBottom: "10px" }}
              >
                {userinfo.codes.length ? "" : "No codes selected."}
              </VendorCardBlankTitle>

              {userinfo.codes.map((item, index) =>
                item !== "null" ? (
                  <Chip
                    key={index}
                    style={{
                      color: "#4945FF",
                      margin: "0 5px 10px 0 ",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={item}
                    value={item}
                    name="chips"
                    onDelete={handleDelete(item)}
                    deleteIcon={
                      <Clear sx={{ height: "18px", width: "18px" }} />
                    }
                  />
                ) : (
                  ""
                ),
              )}
            </Grid>
          </Stack>
        </FormControl>
        <Grid>
          <VendorCardLabel>Additional business areas</VendorCardLabel>
          <TextField
            sx={{
              input: { fontSize: "14px", fontFamily: "var(--font-family-reg)" },
            }}
            id="business_interest_areas"
            placeholder="Enter interest areas"
            variant="standard"
            style={{ width: "100%" }}
            name="business_interest_areas"
            value={userdata.business_interest_areas || ""}
            {...register("business_interest_areas", {
              required: false,
              value: userdata.business_interest_areas,
            })}
            onChange={(e) => onChange(e)}
          />
        </Grid>
        <br />
        {is_domestic === true ? (
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: "lightgray",
                  "&.Mui-checked": {
                    color: "#4059e5",
                  },
                }}
                onChange={handleChange}
                name="pan_declaration"
                checked={checkedPan}
              />
            }
            label={
              <CheckBoxLabel>
                I confirm that the PAN I entered above should be used for all
                TDS deductions made for our company payments
              </CheckBoxLabel>
            }
          />
        ) : (
          ""
        )}
        {isVendorTerms && (
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: "lightgray",
                  "&.Mui-checked": {
                    color: "#4059e5",
                  },
                }}
                onChange={(e) => {
                  if (e.currentTarget.checked) {
                    set_is_accept_vendor_terms_conditions(true);
                  } else {
                    set_is_accept_vendor_terms_conditions(false);
                  }
                }}
                checked={is_accept_vendor_terms_conditions}
                disabled={is_accept_vendor_terms_conditions}
                name="is_accept_vendor_terms_conditions"
              />
            }
            label={
              <CheckBoxLabel>
                I have read & agreed to&nbsp;
                <a
                  href={vendor_terms_condtions_doc}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>{` Terms & Conditions`}</span>
                </a>
              </CheckBoxLabel>
            }
          />
        )}
      </Container>
    </CardContent>
  );

  // useEffect(()=>{
  //   ViewVendordetails();
  // },[]);

  if (isDetailsLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!value) return null;
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Stepper activeStep={activeStep}>
          <div className="stepsDiv">
            {steps.map((label, index) => {
              const stepProps = {};

              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }

              // determine status based on activeStep
              const isCurrent = index === activeStep;
              const isCompleted = index < activeStep;
              let statusClass;
              if (isCompleted) {
                // completed steps use green style
                statusClass = "fstone_1";
              } else if (isCurrent) {
                // current step uses orange
                statusClass = "fstone";
              } else {
                statusClass = "secone";
              }

              return (
                <div
                  key={index}
                  className={`stepcolm ${statusClass} ${
                    isCurrent ? "activeStep" : ""
                  }`}
                  style={{ zIndex: steps.length - index }}
                >
                  <div>
                    {index < activeStep ? (
                      <CheckCircleIcon className="checkedCircle" />
                    ) : (
                      <span>{`${index + 1}. `}</span>
                    )}
                    {label}
                  </div>
                </div>
              );
            })}
          </div>
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}
            <br />
            {activeStep === 0 ? (
              <>
                <form
                  onSubmit={handleSubmit(handleNext)}
                  encType="multipart/form-data"
                >
                  <StyledCard>{card}</StyledCard>
                  <StyledCard>{statutory_information}</StyledCard>

                  {is_domestic && <StyledCard>{msme_information}</StyledCard>}

                  {showRegInfoCard && (
                    <StyledCard>{registration_information}</StyledCard>
                  )}

                  {/* <StyledCard>{documents}</StyledCard> */}

                  {showMajorCustomerList && (
                    <StyledCard>{major_customer_list_ui}</StyledCard>
                  )}

                  <StyledCard>{additional_info}</StyledCard>

                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Button
                      color="inherit"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1, display: "none" }}
                    >
                      Back
                    </Button>

                    <Box sx={{ flex: "1 1 auto" }} />
                    <LoadingButton
                      sx={{
                        textTransform: "none",
                        background: "var(--button-color)",
                        width: "200px",
                        height: "40px",
                      }}
                      color="success"
                      variant="contained"
                      disabled={
                        is_domestic !== true
                          ? false
                          : checkedPan === false
                            ? true
                            : false
                      }
                      type="submit"
                      loading={loading}
                      loadingPosition="start"
                    >
                      Save & Next
                    </LoadingButton>
                  </Box>
                </form>
              </>
            ) : activeStep === 1 ? (
              <>
                {!vendor_details?.Locations?.length && isVendorApproval ? (
                  <BankReg
                    activeStep={activeStep}
                    handleBack={handleBack}
                    checkedPan={checkedPan}
                    steps={steps}
                    registrationtype={vendor_details?.gst_registration_type}
                    clientId={vendorCompany?.id}
                    is_domestic={is_domestic}
                    setActiveStep={setActiveStep}
                    setSkipped={setSkipped}
                    isStepSkipped={isStepSkipped}
                    skipped={skipped}
                    isApproved={isApproved}
                  />
                ) : (
                  <BankRegEdit
                    activeStep={activeStep}
                    handleBack={handleBack}
                    checkedPan={checkedPan}
                    steps={steps}
                    vendor_details={vendor_details}
                    clientId={vendorCompany?.id}
                    is_domestic={is_domestic}
                    setActiveStep={setActiveStep}
                    setSkipped={setSkipped}
                    isStepSkipped={isStepSkipped}
                    skipped={skipped}
                    isApproved={isApproved}
                  />
                )}
              </>
            ) : activeStep === 2 ? (
              <BankDetailsManager
                activeStep={activeStep}
                handleBack={handleBack}
                user_id={vendor_details?.user_id}
                vendor_id={vendor_id || vendor_details?.id}
                is_domestic={is_domestic}
                company_id={vendorCompany?.id}
                setSkipped={setSkipped}
                setActiveStep={setActiveStep}
                isStepSkipped={isStepSkipped}
                skipped={skipped}
                isLocked={
                  vendor_details?.is_pending === true &&
                  vendor_details?.status !== "Saved as Draft"
                }
              />
            ) : activeStep === 3 ? (
              <VendorDocumentRequests
                isStepper={true}
                handleBack={handleBack}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                isLocked={
                  vendor_details?.is_pending === true &&
                  vendor_details?.status !== "Saved as Draft"
                }
                isCreation={false}
                vendor_id={vendor_id || vendor_details?.id}
                skipped={skipped}
                setSkipped={setSkipped}
                isStepSkipped={isStepSkipped}
              />
            ) : (
              <>
                <StyledCard>
                  <CardContent>
                    <VendorCardTitle>Finish Registration</VendorCardTitle>
                    <Typography
                      sx={{
                        my: 2,
                        color: "#4A4A6A",
                        fontSize: "15px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      You have successfully filled in all the registration
                      details. Please click the "Finish" button below to submit
                      your details.
                    </Typography>
                  </CardContent>
                </StyledCard>

                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Button color="inherit" onClick={handleBack} sx={{ mr: 1 }}>
                    Back
                  </Button>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <LoadingButton
                    sx={{
                      textTransform: "none",
                      background: "var(--button-color)",
                      width: "200px",
                      height: "40px",
                    }}
                    color="success"
                    variant="contained"
                    onClick={handleFinalSubmit}
                    loading={finalSubmitLoading}
                  >
                    Finish
                  </LoadingButton>
                </Box>
              </>
            )}
          </React.Fragment>
        )}
      </Box>
      {/* dialog  box*/}
      <Dialog open={editMSMEDailog} onClose={msmeEditCancleHandle} fullWidth maxWidth="sm">
        <DialogTitle style={{ cursor: "move", fontWeight: "Bold" }}>
          Edit MSME Details
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid item xs={12} md={4}>
              <FormControl variant="standard" style={{ width: "100%" }}>
                <VendorCardLabel>
                  MSME registration number <Super>*</Super>
                </VendorCardLabel>
                <TextField
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  InputProps={{
                    disableUnderline: false,
                    disableInjectingGlobalStyles: true,
                  }}
                  InputLabelProps={{
                    disableAnimation: true,
                    disableInjectingGlobalStyles: true,
                  }}
                  size="small"
                  variant="standard"
                  style={{
                    width: "100%",
                    paddingTop: "3px",
                    borderBottom: "1px solid lightgray",
                  }}
                  name="msme_registration_number_edit"
                  placeholder="Enter MSME registration number"
                  {...register("msme_registration_number_edit", {
                    required: editMSMEDailog
                      ? "please enter msme number"
                      : false,
                    pattern: {
                      value: /^UDYAM-[A-Z]{2}-[0-9]{2}-[0-9]{7}$/i,
                      message:
                        "Invalid MSME/Udyam number (Format: UDYAM-XX-00-0000000)",
                    },
                  })}
                  value={editMSMENumber || ""}
                  onChange={(e) => {
                    setEditMSMENumber(e.target.value);
                    setCheckedMSME(false);
                  }}
                  error={Boolean(errors?.msme_registration_number_edit)}
                  helperText={errors?.msme_registration_number_edit?.message}
                />
              </FormControl>
              {msmeLoading && (
                <div style={{ marginTop: "5px" }}>
                  <span
                    style={{
                      fontSize: "13px",
                      color: "var(--button-color, #4945FF)",
                      fontStyle: "italic",
                    }}
                  >
                    Fetching details from Government portal...
                  </span>
                </div>
              )}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ alignItems: "right" }}>
          <Button onClick={msmeEditCancleHandle}>cancel</Button>
          <LoadingButton
            loading={msmeLoading}
            variant="contained"
            size="small"
            onClick={() => {
              if (!watch("company_constitution") && !userdata?.company_constitution) {
                return message.error("Please select Company constitution first");
              }
              if (!editMSMENumber)
                return message.info("Please enter MSME Registration Number");
              dispatch(
                validateMSMENumber({
                  msme: editMSMENumber,
                  company_constitution: userdata?.company_constitution || watch("company_constitution") || "",
                  legal_name: value?.legal_name || "",
                  user_id: value?.user_id,
                }),
              ).then((res) => {
                if (
                  res.payload?.success &&
                  res.payload?.data?.[0]?.status === "completed" &&
                  res.payload?.data?.[0]?.result?.source_output?.status ===
                    "id_found"
                ) {
                  const sourceOutput = res.payload.data[0].result.source_output;
                  const generalDetails = sourceOutput?.general_details || {};
                  const enterpriseTypeData =
                    sourceOutput?.enterprise_type?.[0]?.enterprise_type_1 || {};
                  setValidatedMsmeData({
                    msme_registration_number: editMSMENumber || "",
                    msme_type: generalDetails?.enterprise_type || "",
                    enterprise_name:
                      generalDetails?.enterprise_name ||
                      value?.legal_name ||
                      "",
                    enterprise_activity: generalDetails?.major_activity || "",
                    classification_date:
                      enterpriseTypeData?.classification_date || "",
                    classification_year:
                      enterpriseTypeData?.classification_year || "",
                  });
                  setCheckedMSME(true);
                  setEditMSMEDailog(false);
                } else {
                  setCheckedMSME(false);
                  setValidatedMsmeData(null);
                }
              });
            }}
            sx={{
              background: checkedMSME ? "#2e7d32" : "#4059e5",
              textTransform: "none",
              fontFamily: "var(--font-family-reg)",
              fontSize: "13px",
              "&:hover": {
                background: checkedMSME ? "#1b5e20" : "#3347c4",
              },
            }}
          >
            {checkedMSME ? "Validated ✓" : "Validate"}
          </LoadingButton>
          {checkedMSME && (
            <CheckCircleIcon
              sx={{ color: "#2e7d32", fontSize: "20px", mr: 1 }}
            />
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}

export const StyledCard = materialStyles(Card)`
box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
flex-direction: column;
border: none;
width: 100%;
height: auto;
border-radius: 10px;
margin-bottom: 1em;
`;

export const VendorCardLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #32324d;
`;

export const VendorDisabledFields = styled.div`
  font-family: var(--font-family-semi-bold);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #212134;
`;

export const VendorLabelHolder = styled.div`
  text-align: left;
`;

export const StyledOutlineButton = materialStyles(Button)`
  border: 1px solid var(--button-color);
  color: black;
  height: 40px;
  padding: 8px 30px;
`;

export const StyledFilledButton = materialStyles(Button)`
  background: #1CB697;
  color: #fff;
  height: 40px;
  padding: 8px 30px;
`;

export const AdditionalDetailsCard = materialStyles(Card)`
border: 1px solid #D9D8FF;
background: #F7F9FC;
box-shadow: none;
`;

export const VRSubTitle = styled.div`
  margin-top: -15px;
  margin-bottom: 20px;
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  /* Neutral/600 */

  color: #666687;
`;

export const DocumentLabels = styled.div`
  //styleName: 14/Medium;
  font-family: var(--font-family-med);
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
`;

export const CheckBoxLabel = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Neutral/900 */

  color: #212134;
`;

export const StyledStep = materialStyles(Step)`
box-shadow: 0px 0px 20px rgba(127, 161, 250, 0.15);
flex-direction: column;
border: none;
width: 100%;
height: auto;
border-radius: 10px;
margin-bottom: 1em;
`;

export const CustomButton = materialStyles(Button)`
 ::hover{
   background-color: #1cb;
   font-size: 16.5px;
   transition: all 0.3ms ease-in;
 }
`;

export const SelectSpan = styled.span`
  font-family: var(--font-family-reg);
  font-size: 14px;
  color: "black";
`;

export const StepsSpan = styled.span`
  font-family: var(--font-family-reg);
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  padding-right: 10px;
  color: #4a4a6a;
`;
